import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { Spinner, Modal, ModalBody, ModalHeader, Toast, ToastHeader, ToastBody } from 'reactstrap';
import Header from './Components/navigation/Header';
import Footer from './Components/navigation/Footer';
import ScrollToTop from './Components/navigation/ScrollToTop';
import ToastMessage from './Components/layout/ToastMessage';
import GetStarted from './Views/GetStarted';
import DoAnEvalHome from './Views/DoAnEvalHome';
import EvaluateAbilities from './Views/EvaluateAbilities';
import GatherInfo from './Views/GatherInfo';
import TestDrive from './Views/TestDrive';
import ReviewTab from './Views/ReviewTab';
import UsersTab from './Views/UsersTab';
import StaticAbout from './Views/StaticAbout';
import StaticResources from './Views/StaticResources';
import StaticPrivacy from './Views/StaticPrivacy';
import { ROLES, LOGIN_STATUS, CREATE_STATUS} from './Views/ConstUsers.js';
import { GOALS } from './Views/ConstGoalValues';
import { EVAL_INTRO, TABS, USERS, ABOUT_URL, RESOURCES_URL, PRIVACY_URL } from './Views/ConstPaths';
import { isActivityLowTech, sortActivityList } from './Views/ConstActivityBtns';

import ReactGA from 'react-ga4';

import {
  SubscriptionClient
} from 'subscriptions-transport-ws';

import {
  addRxPlugin,
  createRxDatabase,
  throwIfIsStorageWriteError
} from 'rxdb';

import {v4 as uuid} from 'uuid';
import Enumerable from 'linq';

import { RxDBQueryBuilderPlugin } from 'rxdb/plugins/query-builder';
import {getRxStorageDexie} from 'rxdb/plugins/storage-dexie';
import { wrappedValidateAjvStorage } from 'rxdb/plugins/validate-ajv';
import {wrappedKeyEncryptionCryptoJsStorage} from 'rxdb/plugins/encryption-crypto-js';
import { RxDBLeaderElectionPlugin } from 'rxdb/plugins/leader-election';
import { RxDBMigrationPlugin } from 'rxdb/plugins/migration-schema';
import { RxDBDevModePlugin} from 'rxdb/plugins/dev-mode';

import {
  connect,
  filter
} from 'rxjs/operators';

import{
  pullQueryBuilderFromRxSchema,
  pullStreamBuilderFromRxSchema,
  pushQueryBuilderFromRxSchema,
  replicateGraphQL
} from 'rxdb/plugins/replication-graphql';

import {
  getLastPushCheckpoint
} from 'rxdb/plugins/replication';

import{    
  GRAPHQL_PATH,
  JWT_BEARER_TOKEN,
  accessMethodSchema,
  personSchema,
  sessionSchema,
  clientAccessMethodSchema,
  clientCharacteristicsSchema,
  visionClientCharacteristicsSchema,
  clientGoalSchema,
  trialSchema,
  trialReviewSchema,
  trialTaskSchema,
  trialTaskComponentSchema,
  graphQLGenerationInput
} from './shared/shared';
import HomeWelcome from './Views/HomeWelcome';

import { SignJWT, jwtVerify } from 'jose';

addRxPlugin(RxDBLeaderElectionPlugin);
addRxPlugin(RxDBQueryBuilderPlugin);
addRxPlugin(RxDBMigrationPlugin);
// addRxPlugin(RxDBDevModePlugin);

const _ = require('lodash');

//Utility function to check arrays or strings have any contents
export function hasAValue(value){
  if(Array.isArray(value)){
    if(value.length > 0){
      return true;
    }
  }
  else{ //it's a string. Only truthy if it has contents.
    if(value){
      return true;
    }
  }
  return false;
}

export function hasSameValues(arr1, arr2){
  const set1 = new Set(arr1);
  const set2 = new Set(arr2);

  if (set1.size !== set2.size) return false;

  for (let value of set1) {
    if (!set2.has(value)) return false;
  }

  return true;
}

export function base64ToUint8Array(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

//Local storage keys for storing start-up data
const LS_Provider_KEY = 'an-providerId';
const LS_Client_KEY = 'an-clientId'
const LS_TestDrive_KEY = 'an-testdriveId';
const LS_Task_KEY = 'an-testdriveTaskId';
const LS_RunningTests_KEY = 'an-runningTests';
const LS_StayLoggedIn_Key = 'an_stayLoggedIn';

// created via call: node -e "console.log(require('crypto').randomBytes(32).toString('hex'))"
const DEFAULT_JWT_SECRET = 'b423cefd0f3143f113ca277788b56207b54e47478434357b52618e61ce1ce5c1';

// state vars that have to do with UI
const uiStateVars = ['isLoading', 'loadingMessage', 'showError', 'errorMessage', 'returnToOtherComputer', 'requestTokenPayload', 'accessRequest', 'providerClients'];

//variables to stop database creation and connection to backend for dev
const createDatabase = true; // for devs to enable/disable database usage. Set true to use database storage
const connectToBackend = true; //for devs to enable/disable backend polling. Set true to run the backend
let mountCount = 0;

//mock Client and Provider data  
let Client = {
  id: '',
  alias: "the client", //"Heidi",
  username: "", //"H2O",
  pronouns: ["they", "them", "their"],
  sessionIds: []
}
let Provider = {
  id: '',
  alias: "you",
  username: "",
  pronouns: ["they", "them", "their"],
  sessionIds: []
}
/* mock Session. data model loosely based on BackEnd/session.js */
//TODO reconcile with BackEnd schema
let Session = {
  start: new Date().getTime(),
  end: new Date().getTime(),
  provider: Provider,
  // provider: null,
  client: Client,
  goals: {
    mainGoal: "",
    activities: [],
    priority: "",
    platforms: []
  },
  contexts: {
    environments: [],
    bodyPositions: [],
    indepSetup: "",
    indepUse: ""
  },
  history: {
    hasCurrentMethod: "",
    currentMethods: [], //array of accessMethodUsed objects
    pastMethods: [], //array of accessMethodUsed objects
    platformsUsed: [] 
  },
  physical: { //unpacked from array of bodySite objects
    bodySites: [],
    bodySiteComments: ""
  },
  visual: {
    wearsGlasses: "",
    betterWithGlasses: "",
    hasOtherVisualAids: "",
    visualAidsNotes: "",
    formalEvalNotes: "",
    visionIssues: [],
    issuesNotes: ""
  },
  languageCognition: {
    strengths: "",
    limitations: ""
  },
  other: {
    issues: ""
  },
  //TODO maybe this doesn't need to be persisted, but saving it might allow for graceful resumption of a session
  firstMethodCategory: "",
  //TODO figure out the structure of all this data.
  //the current test-drive
  activeTestDrive: {
    priorityActivity: "", //the client's priority activity
    //setup is the particular access method being used and how it is being used
    setup: {
      name: "",
      accessMethod: {
        accessMethodProfile: {
          id: "",
          name: "",
          type: "", //TODO this isn't used yet
          category: "",
          subCategory: "", //TODO this isn't used yet,
          selectionMethods: [] //array of string values
          //etc. etc.
        }, //all that stuff from the access method database
        currentlyUsed: "", //is it one of the currentMethods?
        pastMethods: "", //is it one of the pastMethods? Erik has this - do we need?
      },
      selectionMethod: "",
      bodySites: [],
      bodySiteComments: "",
      accessories: [],
      positioningNotes: "",
      otherNotes: ""
    },
    currentActivity: "",
    currentActivityName: "", //customizable for a name you give to your own activity
    //undefined initial value ensures that default param values will be used downstream
    //(if we use empty strings here, the settings fields can initialize to empty, which we do not want)
    currentActivityNumTexts: undefined, //'',
    currentActivityLanguage: undefined, //'',
    currentActivityTextUnit: undefined, //'',
    currentActivityNumTargets: undefined, //'',
    currentActivityTargetSize: undefined, //'',
    currentActivityTargetType: undefined, //'',
    currentActivityNumPrompts: undefined, //'',
    currentActivityPromptType: undefined, //'',

    currentActivityWPM: "",
    currentActivityTimePerTarget: "",
    currentActivityAccuracy: "",
    currentActivityObservations: "", 
    currentActivityDuration: '',
    currentActivityRawWPM: '',
    currentActivityExtraActivations: '',
    currentActivityDifficulty: '',
    currentActivityComplete: false,
    currentActivityComponentStats: [],
    //activities are what you've done during the test-drive.
    //each activity includes type, name, observations, measurements, and some setup info
    //TODO: see TestDriveTry for details
    activities: [],

    //these ratings happen once per test-drive (not once per activity)
    clientRating: "",
    clientFeedback: "",
    practitionerRating: "",
    issuesNoted: [],
    practitionerComments: "",
  },
  //when the activeTestDrive is done, it gets stored in completedTestDrives
  completedTestDrives: [],
  //prospects can be "Setups used in Test-drives so far, as well as any Profiles that you've saved but not yet tried."
  prospects: [],
  picks: [],
  report: {
    summaryNotes: "",
    backgroundNotes: "",
    abilitiesNotes: "",
    testdrivesNotes: "",
    decisionsNotes: "",
    recommendationsNotes: ""
  }, //TODO unclear what form the Session report will take, but for now this is a placeholder
  trials: [] //TODO I'm not sure what this is, I think it is from Erik's schema
}

function timeoutPromise(ms){
  return new Promise((_, reject) => setTimeout(() => reject(new Error('Timeout')), ms));
}

async function runAllWithTimeout(promises, ms){
  return Promise.race([Promise.all(promises), timeoutPromise(ms)]);
}

class App extends React.Component {
  constructor(props){
    super(props);
    window.runningTest = props.runningTest;

    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-8QZL8CY3GC'); // <-- Replace with your GA4 Measurement ID
    
    const curURL = new URL(window.location.href);
    var params = new URLSearchParams(curURL.search);
    window.studyParticipant = params.get('studyParticipant');
    window.userType = params.get('user');
    window.resetToken = params.get('token');
    this.retrieveRequestAccessPayload(params.get('requestToken')).then((payload) => {
        window.updateSession('requestTokenPayload', payload);
    });
    window.testDriveClinicianId = params.get('clinicianId');
    window.testDriveTaskId = params.get('testDriveTaskId');
    window.practiceBuiltInActivityType = params.get('activityType');
    window.practiceLanguage = params.get('language');
    window.practiceTextUnit = params.get('textUnit');
    window.practiceTargetSize = params.get('targetSize');
    window.practiceTargetType = params.get('targetType');
    window.practicePromptType = params.get('promptType');

    //App's state holds data that may change in any of the child components (anywhere in the app).
    //Flatten out the Session object so that setState can handle each piece in the same way, as a key/value pair.
    //  Also, React isn't oriented to work with nested states:
    //  https://stackoverflow.com/questions/43040721/how-to-update-nested-state-properties-in-react
    //TODO this flattening could become a function, I think, just to keep the constructor a bit cleaner

    // TODO initialization here vs getInitialStateObject. Violates DRY? Creates additional renders, I think.
    // move toward using getInitialStateObject() here.  
    this.state = {
      //local state to manage status (loading / not loading, etc.)
      isLoading: false,
      loadingMessage: "",
      showError: false,
      errorMessage: '',
      showTempMessage: false,
      tempMessage: null, //tried initializing as {} but that breaks cascade in updateSession that toggles showTempMessage
      // state that holds data for user account stuff:
      userToUpdate: null,
      stayLoggedIn: false,
      requestTokenPayload: null, //used to store the payload from a request access token
      //state that holds data for this session:
      client:Session.client,
      clientId: Session.client.id,
      // provider: Session.provider,
      // providerId: Session.provider.id,
      provider: null,
      providerId: null,
      mainGoal: Session.goals.mainGoal,
      activities: Session.goals.activities,
      priority: Session.goals.priority,
      platforms: Session.goals.platforms,
      environments: Session.contexts.environments,
      bodyPositions: Session.contexts.bodyPositions,
      indepSetup: Session.contexts.indepSetup,
      indepUse: Session.contexts.indepUse,
      hasCurrentMethod: Session.history.hasCurrentMethod,
      currentMethods: Session.history.currentMethods,
      pastMethods: Session.history.pastMethods,
      platformsUsed: Session.history.platformsUsed,
      bodySites: Session.physical.bodySites,
      bodySiteComments: Session.physical.bodySiteComments,
      wearsGlasses: Session.visual.wearsGlasses,
      betterWithGlasses: Session.visual.betterWithGlasses,
      hasOtherVisualAids: Session.visual.hasOtherVisualAids,
      visualAidsNotes: Session.visual.visualAidsNotes,
      formalEvalNotes: Session.visual.formalEvalNotes,
      visionIssues: Session.visual.visionIssues,
      issuesNotes: Session.visual.issuesNotes,
      strengths: Session.languageCognition.strengths,
      limitations: Session.languageCognition.limitations,
      otherIssues: Session.other.issues,
      //state needed for the test-drive/choose section:
      firstMethodCategory: Session.firstMethodCategory,
      activeTestDriveId: Session.activeTestDrive.id,


      //TD object experiment with activeTestDrive object. Start with the test-drive/choose vars 
      activeTestDrive: {
        //we are still using this.state.activeTestDriveId but a .trialId here is also needed to manage the completedTestDrives array
        trialId: Session.activeTestDrive.id,
        activeAccessMethodID: Session.activeTestDrive.setup.accessMethod.accessMethodProfile.id,
        activeAccessMethodName: Session.activeTestDrive.setup.accessMethod.accessMethodProfile.name,
        activeAccessMethodCategory: Session.activeTestDrive.setup.accessMethod.accessMethodProfile.category,
        activeAccessMethodSelectionMethods: Session.activeTestDrive.setup.accessMethod.accessMethodProfile.selectionMethods,
        activeSetupSelectionMethod: Session.activeTestDrive.setup.selectionMethod,
        activeSetupBodySite: Session.activeTestDrive.setup.bodySites,
        activeSetupBodySiteComments: Session.activeTestDrive.setup.bodySiteComments,
        activeSetupAccessories: Session.activeTestDrive.setup.accessories,
        activeSetupPositioningNotes: Session.activeTestDrive.setup.positioningNotes,
        activeSetupOtherNotes: Session.activeTestDrive.setup.otherNotes,
        activeSetupName: Session.activeTestDrive.setup.name,

        //for the test-drive/try section:
        activeTestDriveActivities: Session.activeTestDrive.activities,
        activeTestDriveCurrentActivity: Session.activeTestDrive.currentActivity,
        activeTestDriveCurrentActivityName: Session.activeTestDrive.currentActivityName,
        activeTestDriveCurrentActivityNumTexts: Session.activeTestDrive.currentActivityNumTexts,
        activeTestDriveCurrentActivityLanguage: Session.activeTestDrive.currentActivityLanguage,
        activeTestDriveCurrentActivityTextUnit: Session.activeTestDrive.currentActivityTextUnit,
        activeTestDriveCurrentActivityNumTargets: Session.activeTestDrive.currentActivityNumTargets,
        activeTestDriveCurrentActivityTargetSize: Session.activeTestDrive.currentActivityTargetSize,
        activeTestDriveCurrentActivityTargetType: Session.activeTestDrive.currentActivityTargetType,
        activeTestDriveCurrentActivityNumPrompts: Session.activeTestDrive.currentActivityNumPrompts,
        activeTestDriveCurrentActivityPromptType: Session.activeTestDrive.currentActivityPromptType,

        activeTestDriveCurrentActivityNotes: Session.activeTestDrive.currentActivityObservations,
        activeTestDriveCurrentActivityDuration: Session.activeTestDrive.currentActivityDuration,
        activeTestDriveCurrentActivityRawWPM: Session.activeTestDrive.currentActivityRawWPM,
        activeTestDriveCurrentActivityWPM: Session.activeTestDrive.currentActivityWPM,
        activeTestDriveCurrentActivityTargetsPerMinute: Session.activeTestDrive.currentActivityTimePerTarget,
        activeTestDriveCurrentActivityAccuracy: Session.activeTestDrive.currentActivityAccuracy,
        activeTestDriveCurrentActivityExtraActivations: Session.activeTestDrive.currentActivityExtraActivations,
        activeTestDriveCurrentActivityDifficulty: Session.activeTestDrive.currentActivityDifficulty,
        activeTestDriveCurrentActivityComponentStats: Session.activeTestDrive.currentActivityComponentStats,

        activeTestDriveClientRating: Session.activeTestDrive.clientRating,
        activeTestDriveClientFeedback: Session.activeTestDrive.clientFeedback,
        activeTestDrivePractitionerRating: Session.activeTestDrive.practitionerRating,
        activeTestDriveIssuesNoted: Session.activeTestDrive.issuesNoted,
        activeTestDrivePractitionerComments: Session.activeTestDrive.practitionerComments,
  
      },
      completedTestDrives: Session.completedTestDrives,
      prospects: Session.prospects,
      picks: Session.picks,
      summaryNotes: Session.report.summaryNotes,
      backgroundNotes: Session.report.backgroundNotes,
      abilitiesNotes: Session.report.abilitiesNotes,
      testdrivesNotes: Session.report.testdrivesNotes,
      decisionsNotes: Session.report.decisionsNotes,
      recommendationsNotes: Session.report.recommendationsNotes
    };
    console.log("Constructing App, with state: " + JSON.stringify(this.state));

    this.saveAndResetTestDrive = this.saveAndResetTestDrive.bind(this);
    window.logoutOfProvider = this.logoutOfProvider.bind(this);
    window.updateSession = this.updateSession.bind(this);
    window.createSessionFromPreviousSession = this.createSessionFromPreviousSession.bind(this);
    window.flattenDbSession = this.flattenDbSession.bind(this);
    window.flattenCharacteristics = this.flattenCharacteristics.bind(this);
    window.flattenVisionCharacteristics = this.flattenVisionCharacteristics.bind(this);
    window.flattenTrialTask = this.flattenTrialTask.bind(this);
    window.compareSessions = this.compareSessions.bind(this);
    window.compareCharacteristics = this.compareCharacteristics.bind(this);
    window.compareVision = this.compareVision.bind(this);
    window.runRemotePractice = this.runRemotePractice.bind(this);
    window.getMostRecentSession = this.getMostRecentSession.bind(this);
    window.validateEmail = this.validateEmail.bind(this);
    window.checkUserCredentials = this.checkUserCredentials.bind(this);
    window.updateUserCredentials = this.updateUserCredentials.bind(this);
    window.resetPassword = this.resetPassword.bind(this);
    window.createUser = this.createUser.bind(this);
    window.updateUser = this.updateUser.bind(this);
    window.refreshPractitioner = this.refreshPractitioner.bind(this);
    window.getAllClients = this.getAllClients.bind(this);
    window.sendClientAccessRequest = this.sendClientAccessRequest.bind(this);
    window.createClientAccessRequest = this.createClientAccessRequest.bind(this);
    window.clientAccessApproval = this.clientAccessApproval.bind(this);
  }
  
  saveAndResetTestDrive(){
    const testDriveToSave = this.state.activeTestDrive; 
    console.log("calling saveAndResetTestDrive with td: " + JSON.stringify(testDriveToSave));
    //do nothing, unless we have some data in the testDriveToAdd
    //this ensures that completedTestDrives and prospects are free of empty objects
    if(this.testDriveHasAnyValues(testDriveToSave)){
      this.saveActiveTestDrive();
    }
    //reset the active Test Drive
    this.updateSession('activeTestDriveId', '');
    this.resetActiveTestDrive();
  }

  //Put all activeTestDrive properties, and the testDriveId, into a format that will go into completedTestDrives, prospects, picks
  //This is mainly just a translator of property names. 
  //And a way to put the flat activeTestDriveId into the object.
  packageUpActiveTestDrive(){
    const testDriveToAdd = {};
    testDriveToAdd.trialId = this.state.activeTestDriveId;

    testDriveToAdd.accessMethodID = this.state.activeTestDrive.activeAccessMethodID;
    testDriveToAdd.accessMethodName = this.state.activeTestDrive.activeAccessMethodName;
    testDriveToAdd.accessMethodCategory = this.state.activeTestDrive.activeAccessMethodCategory;
    testDriveToAdd.accessMethodSelectionMethods = this.state.activeTestDrive.activeAccessMethodSelectionMethods;
    testDriveToAdd.setupSelectionMethod = this.state.activeTestDrive.activeSetupSelectionMethod;
    testDriveToAdd.setupBodySite = this.state.activeTestDrive.activeSetupBodySite;
    testDriveToAdd.setupBodySiteComments = this.state.activeTestDrive.activeSetupBodySiteComments;
    testDriveToAdd.setupAccessories = this.state.activeTestDrive.activeSetupAccessories;
    testDriveToAdd.setupPositioningNotes = this.state.activeTestDrive.activeSetupPositioningNotes;
    testDriveToAdd.setupOtherNotes = this.state.activeTestDrive.activeSetupOtherNotes;
    testDriveToAdd.setupName = this.state.activeTestDrive.activeSetupName;
    testDriveToAdd.currentActivity = this.state.activeTestDrive.activeTestDriveCurrentActivity;
    testDriveToAdd.currentActivityName = this.state.activeTestDrive.activeTestDriveCurrentActivityName;
    testDriveToAdd.currentActivityNumTexts = this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts;
    testDriveToAdd.currentActivityLanguage = this.state.activeTestDrive.activeTestDriveCurrentActivityLanguage;
    testDriveToAdd.currentActivityTextUnit = this.state.activeTestDrive.activeTestDriveCurrentActivityTextUnit;
    testDriveToAdd.currentActivityNumTargets = this.state.activeTestDrive.activeTestDriveCurrentActivityNumTargets;
    testDriveToAdd.currentActivityTargetSize = this.state.activeTestDrive.activeTestDriveCurrentActivityTargetSize;
    testDriveToAdd.currentActivityTargetType = this.state.activeTestDrive.activeTestDriveCurrentActivityTargetType;
    testDriveToAdd.currentActivityNumPrompts = this.state.activeTestDrive.activeTestDriveCurrentActivityNumPrompts;
    testDriveToAdd.currentActivityPromptType = this.state.activeTestDrive.activeTestDriveCurrentActivityPromptType;
    testDriveToAdd.currentActivityDuration = this.state.activeTestDrive.activeTestDriveCurrentActivityDuration;
    testDriveToAdd.currentActivityRawWPM = this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM;
    testDriveToAdd.currentActivityWPM = this.state.activeTestDrive.activeTestDriveCurrentActivityWPM;
    testDriveToAdd.currentActivityTimePerTarget = this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute;
    testDriveToAdd.currentActivityAccuracy = this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy;
    testDriveToAdd.currentActivityExtraActivations = this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations;
    testDriveToAdd.currentActivityDifficulty = this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty;
    testDriveToAdd.currentActivityComponentStats = this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats;
    testDriveToAdd.currentActivityNotes = this.state.activeTestDrive.activeTestDriveCurrentActivityNotes;
    testDriveToAdd.currentActivityComplete = this.state.activeTestDrive.activeTestDriveCurrentActivityComplete;
    testDriveToAdd.priorityActivity = this.state.priority; 
    testDriveToAdd.activities = this.state.activeTestDrive.activeTestDriveActivities;
    testDriveToAdd.clientRating = this.state.activeTestDrive.activeTestDriveClientRating;
    testDriveToAdd.clientFeedback = this.state.activeTestDrive.activeTestDriveClientFeedback;
    testDriveToAdd.practitionerRating = this.state.activeTestDrive.activeTestDrivePractitionerRating;
    testDriveToAdd.issuesNoted = this.state.activeTestDrive.activeTestDriveIssuesNoted;
    testDriveToAdd.practitionerComments = this.state.activeTestDrive.activeTestDrivePractitionerComments;
    
    //TODO init properties needed in picks (since picks come from testdrives)
    testDriveToAdd.needsMet = [];

    return(testDriveToAdd);

  }
  //Puts the current activeTestDrive in the completedTestDrives and prospects arrays.
  //If the activeTestDrive is already in completedTestDrives, it updates the info. Otherwise it concats.
  //This now happens at every step of the /test-drive route, so the activeTestDrive may not in fact be "completed" (eventually may change completedTestDrives to a different name)
  //This approach reduces data loss when users jump around using tab navigation data  
  saveActiveTestDrive(){
    if(this.testDriveHasAnyValues(this.state.activeTestDrive)){
      // const testDriveToSave = {
      //   ...this.state.activeTestDrive,
      //   trialId: this.state.activeTestDriveId,
      // };  
      const testDriveToSave = this.packageUpActiveTestDrive();
      const completedIndex = 
        this.state.completedTestDrives.findIndex((td) => td.trialId === this.state.activeTestDriveId);
      const prospectsIndex = 
        this.state.prospects.findIndex((td) => td.trialId === this.state.activeTestDriveId);
      const picksIndex = 
        this.state.picks.findIndex((td) => td.trialId === this.state.activeTestDriveId);

      //activeTestDrive not in completedTestDrives: put it in completed and prospects
      if (completedIndex === -1){
        this.setState((prevState) => {
          return{
            completedTestDrives: prevState.completedTestDrives.concat(testDriveToSave),
            prospects: prevState.prospects.concat(testDriveToSave)
          };
        }, 
        () => {
          this.saveTestDrivesToSession();
          this.saveProspectsToSession();
        });
      }
      //activeTestDrive already in completedTestDrives: update existing info
      else{
        //the usual case is that the activeTestDrive is also in Prospects:
        if (prospectsIndex > -1){
          this.setState((prevState) => {
            return{
              completedTestDrives: prevState.completedTestDrives.map((td, i) => {
                if(i === completedIndex){
                  return testDriveToSave;
                }
                else{
                  return td;
                }
              }),
              prospects: prevState.prospects.map((td, i) => {
                if(i === prospectsIndex){
                  return testDriveToSave;
                }
                else{
                  return td;
                }
              })
            };
          }, 
          () => {
            this.saveTestDrivesToSession();
            this.saveProspectsToSession();
          });
        }
        //but it might be in Picks, if user has jumped ahead and moved it to Picks for some reason
        else if (picksIndex > -1){
          console.log("*** saveActiveTestDrive: case where atd is in Picks");
          this.setState((prevState) => {
            return{
              completedTestDrives: prevState.completedTestDrives.map((td, i) => {
                if(i === completedIndex){
                  return testDriveToSave;
                }
                else{
                  return td;
                }
              }),
              picks: prevState.picks.map((td, i) => {
                if(i === picksIndex){
                  return testDriveToSave;
                }
                else{
                  return td;
                }
              })
            };
          }, 
          () => {
            this.saveTestDrivesToSession();
            this.savePicksToSession();
          });
        }
        //if there's a weird edge case where it's not in Prospects OR Picks, we still need to update completedTestDrives
        else{
          this.setState((prevState) => {
            return{
              completedTestDrives: prevState.completedTestDrives.map((td, i) => {
                if(i === completedIndex){
                  return testDriveToSave;
                }
                else{
                  return td;
                }
              }),
            };
          }, 
          () => {
            this.saveTestDrivesToSession();
          });

        }
      }
    }
    // else alert("There's no data in the test-drive. Nothing to save.");
  }

  async createRequestAccessToken(clientUsername){
    const secretStr = process.env.REACT_APP_REQUEST_USER_ACCESS_TOKEN_SECRET || DEFAULT_JWT_SECRET;
    const secret = new TextEncoder().encode(secretStr); // Must be Uint8Array
    const payload = {
      requestingClinicianName: this.state.provider.username,
      requestingClinicianId: this.state.providerId,
      clientUsername: clientUsername
    };
    const token = await new SignJWT(payload)
      .setProtectedHeader({ alg: 'HS256' })
      .setIssuedAt()
      .setExpirationTime('7d')
      .sign(secret);
    return token;
  }

  async retrieveRequestAccessPayload(token){
    if(!token){
      return null;
    }
    try {
      const secretStr = process.env.REACT_APP_REQUEST_USER_ACCESS_TOKEN_SECRET || DEFAULT_JWT_SECRET;
      const secret = new TextEncoder().encode(secretStr); // Must be Uint8Array
      const verifyResult = await jwtVerify(token, secret);
      return verifyResult.payload;
    } catch (err) {
      console.error('Error verifying token:', err);
      return null;
    }
  }

  async createClientAccessRequest(clinicianEmail, clientUsername){
    const requestToken = await this.createRequestAccessToken(clientUsername);
    const url = `${window.location.origin}?requestToken=${requestToken}`;
    const bodyText = `Practitioner ${this.state.provider.alias} is requesting access to one of your Access Navigator clients.

Topic: Request for Access to Access Navigator Client
Link: ${url}

I am requesting shared access to the client data for ${clientUsername}. Please use the link above to approve my access request.`;
    const request = {
      subject: 'Request for Access to Access Navigator Client',
      clinicianEmail: clinicianEmail,
      clientUsername: clientUsername,
      url: url,
      body: bodyText,
    };
    this.updateSession('accessRequest', request);
  }

  async sendClientAccessRequest(sendRequestType){
    switch(sendRequestType){
      case 1: // share request via share API
        try{
          if(navigator.share){
            await navigator.share({
              title: this.state.accessRequest?.subject,
              text: this.state.accessRequest?.body,
              url: this.state.accessRequest?.url
            });
          }
        }catch(err){}
        break; 
      case 2: // copy entire request to clipboard
        try{
          await navigator.clipboard.writeText(this.state.accessRequest?.body);
          this.updateSession('tempMessage', {
            icon: 'success',
            title: 'Request Copied',
            message: `The full request message has been copied to your clipboard.`,
            duration: 4000
          });
        } catch(err){}
        break;
      case 3: // copy the link to clipboard
        try{
          await navigator.clipboard.writeText(this.state.accessRequest?.url);
          this.updateSession('tempMessage', {
            icon: 'success',
            title: 'Link Copied',
            message: `The request link has been copied to your clipboard.`,
            duration: 4000
          });
        } catch(err){}
        break;
      case 4: // email request
        const body = encodeURIComponent(this.state.accessRequest?.body);
        window.open(`mailto:${this.state.accessRequest?.clinicianEmail}?subject=${this.state.accessRequest?.subject}&body=${body}`);
        break;
      default:
        break;
    }
    this.updateSession('accessRequest', null);
    return true;
  }

  async clientAccessApproval(accessGranted){
    if(accessGranted){
      var user = await window.db.person.findOne({selector:{username: this.state.requestTokenPayload?.clientUsername}}).exec();
      const userJson = user.toJSON();
      const currentRelations = Array.isArray(userJson.relationIds) ? userJson.relationIds : [];
      const updatedRelations = currentRelations.includes(this.state.requestTokenPayload?.requestingClinicianId)
        ? currentRelations
        : [...currentRelations, this.state.requestTokenPayload?.requestingClinicianId];
      await user.incrementalPatch({ 
        relationIds: updatedRelations, 
        updatedAt:new Date().getTime()
      });

      try{
      // add updatedRelations to mostRecentSession for user
      const mostRecentSession = await window.db.session.findOne({selector: {clientId:userJson.id}, sort:[{'updatedAt': 'desc'}]}).exec();
      if (mostRecentSession) {
        const mostRecentSessionJson = mostRecentSession.toJSON();
        const currentRelationsInSession = Array.isArray(mostRecentSessionJson.clinicianIds) ? mostRecentSessionJson.clinicianIds : [];
        const updatedRelationsInSession = currentRelationsInSession.includes(this.state.requestTokenPayload?.requestingClinicianId)
          ? currentRelationsInSession
          : [...currentRelationsInSession, this.state.requestTokenPayload?.requestingClinicianId];
        await mostRecentSession.incrementalPatch({ 
          clinicianIds: updatedRelationsInSession, 
          updatedAt: new Date().getTime()
        });

        // update clientCharacteristics to include the new clinician
        const clientCharacteristics = await window.db.clientCharacteristics.findOne({selector:{id: mostRecentSessionJson.characteristicsId}}).exec();
        if (clientCharacteristics) {
          const clientCharacteristicsJson = clientCharacteristics.toJSON();
          await clientCharacteristics.incrementalPatch({ 
            clinicianIds: updatedRelationsInSession, 
            updatedAt: new Date().getTime()
        });

          // update visionClientCharacteristics to include the new clinician
          const visionClientCharacteristics = await window.db.visionClientCharacteristics.findOne({selector:{id: clientCharacteristicsJson.visionId}}).exec();
          if (visionClientCharacteristics) {
            await visionClientCharacteristics.incrementalPatch({ 
              clinicianIds: updatedRelationsInSession, 
              updatedAt: new Date().getTime()
            });
          }
        }

        // update all goals within the session to include the new clinician
        const goals = await window.db.clientGoal.find({selector:{id: {$in: mostRecentSessionJson.goalIds}}}).exec();
        for (const goal of goals) {
          await goal.incrementalPatch({ 
            clinicianIds: updatedRelationsInSession,
            updatedAt: new Date().getTime() 
          });
        }

        // update all history objects within the session to include the new clinician
        const histories = await window.db.clientAccessMethod.find({selector:{id: {$in: mostRecentSessionJson.historyIds}}}).exec();
        for (const history of histories) {
          await history.incrementalPatch({ 
            clinicianIds: updatedRelationsInSession,
            updatedAt: new Date().getTime()
          });
        }

        // update all trials within the session to include the new clinician
        const trials = await window.db.trial.find({selector:{id: {$in: mostRecentSessionJson.trialIds}}}).exec();
        for (const trial of trials) {
          const trialJson = trial.toJSON();
          await trial.incrementalPatch({ 
            clinicianIds: updatedRelationsInSession,
            updatedAt: new Date().getTime()
          });

          // update all trial tasks within the trial to include the new clinician
          const trialTasks = await window.db.trialTask.find({selector: {id:{$in:trialJson.trialTaskIds}}}).exec();
          for (const trialTask of trialTasks) {
            const trialTaskJson = trialTask.toJSON();
            await trialTask.incrementalPatch({ 
              clinicianIds: updatedRelationsInSession,
              updatedAt: new Date().getTime()
            });

            // update all trial task components within the trial task to include the new clinician
            const trialTaskComponents = await window.db.trialTaskComponent.find({selector: {id:{$in:trialTaskJson.trialTaskComponentIds}}}).exec();
            for (const trialTaskComponent of trialTaskComponents) {
              await trialTaskComponent.incrementalPatch({ 
                clinicianIds: updatedRelationsInSession,
                updatedAt: new Date().getTime()
              });
            }
          }

          // update all trial reviews within the trial to include the new clinician
          const trialReviews = await window.db.trialReview.find({selector:{trialId: trialJson.id}}).exec();
          for (const trialReview of trialReviews) {
            await trialReview.incrementalPatch({ 
              clinicianIds: updatedRelationsInSession,
              updatedAt:new Date().getTime() 
            });
          }
        }
      }
    }catch (error) {
      console.error('Error updating most recent session:', error);
    }

      this.updateSession(
        'tempMessage', {
          icon: 'success',
          title: 'Access Granted',
          message: `Access granted to ${this.state.requestTokenPayload?.requestingClinicianName}.`,
          duration: 4000
        }, this.updateSession('requestTokenPayload', null));
    }
    else{
      this.updateSession(
        'tempMessage',  {
          icon: 'info',
          title: 'Access Denied',
          message: `Access denied to ${this.state.requestTokenPayload?.requestingClinicianName}.`,
          duration: 4000
        }, this.updateSession('requestTokenPayload', null));
    }
    if (window.location.search.includes('requestToken=')) {
      const url = new URL(window.location.href);
      url.searchParams.delete('requestToken');
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
  }

  //Returns false if all values are empty (empty strings, empty Arrays)
  //Otw returns true.
  //depends on testDrive having values that are only Arrays or Strings
  testDriveHasAnyValues(testDrive){
    let valuesArray = Object.values(testDrive);
    return(valuesArray.some(hasAValue));
  }

  resetActiveTestDrive(){
    console.log("resetting test drive state");
    const emptyTestDrive = {
      activeAccessMethodID: '',
      activeAccessMethodName: '',
      activeAccessMethodCategory: '',
      activeAccessMethodSelectionMethods: [],
      activeSetupSelectionMethod: '',

      activeSetupBodySite: [],
      activeSetupBodySiteComments: '',
      activeSetupAccessories: [],
      activeSetupPositioningNotes: '',
      activeSetupOtherNotes: '',
      activeSetupName: '',

      activeTestDriveActivities: [],

      activeTestDriveClientRating: '',
      activeTestDriveClientFeedback: '',
      activeTestDrivePractitionerRating: '',
      activeTestDriveIssuesNoted: [],
      activeTestDrivePractitionerComments: '',

      //these default settings MUST be undefined, to allow the test to fill in default values.
      // if they are empty strings, the text field for entering them will be empty, rather than default value.
      // and if they are actual default values, the testDriveHasAnyValues() method will not be correct.
      activeTestDriveCurrentActivityNumTexts: undefined, //'', //('' + DEFAULT_TEXTS_IN_TEST),
      activeTestDriveCurrentActivityLanguage: undefined, //'', //DEFAULT_TEXT_LANGUAGE,
      activeTestDriveCurrentActivityTextUnit: undefined, //'', //DEFAULT_TEXT_UNIT,
      activeTestDriveCurrentActivityNumTargets: undefined, //'', //('' + DEFAULT_TARGETS_IN_TEST),
      activeTestDriveCurrentActivityTargetSize: undefined, //'', //('' + DEFAULT_TARGET_SIZE),
      activeTestDriveCurrentActivityTargetType: undefined, //'', //DEFAULT_TARGET_TYPE,
      activeTestDriveCurrentActivityNumPrompts: undefined, //'', //('' + DEFAULT_HITS_IN_TEST),
      activeTestDriveCurrentActivityPromptType: undefined, //'', //DEFAULT_TARGET_TYPE,

      activeTestDriveCurrentActivityDuration: '',
      activeTestDriveCurrentActivityRawWPM: '',
      activeTestDriveCurrentActivityWPM: '',
      activeTestDriveCurrentActivityTargetsPerMinute: '',
      activeTestDriveCurrentActivityAccuracy: '',
      activeTestDriveCurrentActivityExtraActivations: '',
      activeTestDriveCurrentActivityDifficulty: '',
      activeTestDriveCurrentActivityComponentStats: [],
      activeTestDriveCurrentActivityNotes: '',
      activeTestDriveCurrentActivityComplete: false
    };
    this.setState({
      activeTestDrive: emptyTestDrive
    });
    //try this to fix lingering activity data during test-drives
    // this.resetActiveTestDriveTask();
    window.updateSession('activeTrialTaskId', '');
  }

  resetActiveTestDriveTask(){
    console.log("resetting test drive task state -- NO OP for now");
    // this.setState = ({
    //   activeTestDrive: {
    //     ...this.state.activeTestDrive,
    //     activeTestDriveCurrentActivity: '',
    //     activeTestDriveCurrentActivityName: '',
    //     activeTestDriveCurrentActivityNumTexts: ('' + DEFAULT_TEXTS_IN_TEST),
    //     activeTestDriveCurrentActivityLanguage: DEFAULT_TEXT_LANGUAGE,
    //     activeTestDriveCurrentActivityTextUnit: DEFAULT_TEXT_UNIT,
    //     activeTestDriveCurrentActivityNumTargets: ('' + DEFAULT_TARGETS_IN_TEST),
    //     activeTestDriveCurrentActivityTargetSize: ('' + DEFAULT_TARGET_SIZE),
    //     activeTestDriveCurrentActivityTargetType: DEFAULT_TARGET_TYPE,
    //     activeTestDriveCurrentActivityNumPrompts: ('' + DEFAULT_HITS_IN_TEST),
    //     activeTestDriveCurrentActivityPromptType: DEFAULT_TARGET_TYPE,
    //     activeTestDriveCurrentActivityDuration: '',
    //     activeTestDriveCurrentActivityRawWPM: '',
    //     activeTestDriveCurrentActivityWPM: '',
    //     activeTestDriveCurrentActivityTargetsPerMinute: '',
    //     activeTestDriveCurrentActivityAccuracy: '',
    //     activeTestDriveCurrentActivityExtraActivations: '',
    //     activeTestDriveCurrentActivityDifficulty: '',
    //     activeTestDriveCurrentActivityComponentStats: [],
    //     activeTestDriveCurrentActivityNotes: '',
    //     activeTestDriveCurrentActivityComplete: false

    //   }
    // });
  }

  updateHeadersWithClinician(clinician){
    window.waitForDataPull = true;
    window.personReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      relationIds: clinician ? [clinician] : ['']
    });
    window.personReplicationState.reSync();

    window.clientAccessMethodReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.clientAccessMethodReplicationState.reSync();

    window.clientCharacteristicsReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.clientCharacteristicsReplicationState.reSync();

    window.clientGoalReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.clientGoalReplicationState.reSync();

    window.sessionReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.sessionReplicationState.reSync();

    window.trialReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.trialReplicationState.reSync();

    window.trialReviewReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.trialReviewReplicationState.reSync();

    window.trialTaskReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.trialTaskReplicationState.reSync();

    window.trialTaskComponentReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.trialTaskComponentReplicationState.reSync();

    window.visionClientCharacteristicsReplicationState.setHeaders({
      Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
      clinicianIds: clinician ? [clinician] : ['']
    });
    window.visionClientCharacteristicsReplicationState.reSync();

  }

  // This is a way to allow a logout from outside of the Users tab, but not currently used.
  //Functionally equivalent to UsersTab.logout()
  logoutOfProvider(){
    this.updateSession('provider', null);
  }

  //If there is a person in the database with this username, send a reset link to their email.
  //It does this by setting the user's tokenExpiration to Now+30 minutes.
  //This tells the backend to create a new token for that user and send an email to the user with that token in the URL.
  //(See www/index.js for the backend code)
  async resetPassword(username){
    if(window.db) {
      if(username){
        console.debug('resetPassword: username=[' + username + "]");
        var user = await window.db.person.findOne({selector:{username: username}}).exec();
        if(user && (user.email || this.validateEmail(user.username))){
          await user.incrementalPatch({
            token: '',
            tokenExpiration: new Date().getTime() + 3600000,
            updatedAt: new Date().getTime()
          });
          return true;
        }
      }
    }
    return false;
  }

  async getMostRecentSession(user){
    if(window.db && user && user.sessionIds){
      var sessionsFromIds = await window.db.session.find({selector: {id: {$in: user.sessionIds}}, sort:[{'updatedAt': 'desc'}]}).exec();
      var sessionsFromClient = await window.db.session.find({selector: {clientId:user.id}, sort:[{'updatedAt': 'desc'}]}).exec();
      var notTheSame = sessionsFromIds != null && sessionsFromClient != null && sessionsFromIds.length !== sessionsFromClient.length;
      if(notTheSame){
        console.error('sessionIds out of sync: sessionIds=[' + sessionsFromIds.length + '] from client=[' + sessionsFromClient.length + ']');
        console.dir(sessionsFromIds);
        console.dir(sessionsFromClient);
      }
      //var session = await window.db.session.findOne({selector: {id: {$in: user.sessionIds}}, sort:[{'updatedAt': 'desc'}]}).exec();
      var session = await window.db.session.findOne({selector: {clientId:user.id}, sort:[{'updatedAt': 'desc'}]}).exec();
      return session ? session.toJSON() : session;
    }
  }

  async refreshPractitioner(){
    if(window.db && this.state.providerId){
      console.debug('Refreshing practitioner with id: ' + this.state.providerId);
      var practitioner = await window.db.person.findOne({selector:{id: this.state.providerId}}).exec();
      if(practitioner){
        practitioner = practitioner.toJSON();
        this.updateSession('provider', practitioner);
        this.updateHeadersWithClinician(practitioner.id);
        this.getAllClients(practitioner);
        return practitioner;
      } else {
        console.warn('No practitioner found with id: ' + this.state.providerId);
      }
    }
    return null;
  }

  async getAllClients(practitioner){
    if(window.db && practitioner){
      var waitCount = 0;
      // wait for data to come in or timeout after 1 second
      while (window.waitForDataPull && waitCount < 10) {
        ++waitCount;
        await new Promise(resolve => setTimeout(resolve, 100)); // Check every 100ms
      }

      // var allPersons = await window.db.person.find().exec();
      // console.warn('getAllClients: allPersons.length=' + allPersons.length);
      // console.dir(allPersons.map(p => p.toJSON()));

      try{
      var clientsFromProvider = practitioner.relationIds ? await window.db.person.find({
        selector:{id: {$in: practitioner.relationIds}}
      }).exec() : [];

      var allClients = await window.db.person.find({
        selector: { relationIds: { $in: [practitioner.id] }}
      }).exec();

      if((!clientsFromProvider || clientsFromProvider.length === 0) && (!allClients || allClients.length === 0)){
        //console.warn('No clients found for practitioner with relationIds: ' + practitioner.relationIds);
        return [];
      }

      var clientsFromProviderJsons = clientsFromProvider
          .map(x => x.toJSON())
          .filter(c => c.role === ROLES.CLIENT)
          .sort((a, b) => b.updatedAt - a.updatedAt);
      var allClientsJsons = allClients
          .map(x => x.toJSON())
          .filter(c => c.role === ROLES.CLIENT)
          .sort((a, b) => b.updatedAt - a.updatedAt);

      if(allClientsJsons.Length == clientsFromProviderJsons.length){
        return clientsFromProviderJsons;
      }

      // Find elements that are in allClients but not in clientsFromProvider and Add to practitioner.relationIds
      var missingClientJsons = allClientsJsons.filter(c => 
        !clientsFromProviderJsons.some(cp => cp.id === c.id)
      );

      if(missingClientJsons.length == 0){
        return clientsFromProviderJsons;
      }

      // Add missing clients to practitioner.relationIds
      for (const client of missingClientJsons) {
        if(!practitioner.relationIds.includes(client.id)){
          practitioner.relationIds.push(client.id);
        }
      }

      // Update the practitioner in the database
      var providerInDb = await window.db.person.findOne({selector:{id: practitioner.id}}).exec();
      if(providerInDb){
        await providerInDb.incrementalPatch({
          relationIds: practitioner.relationIds,
          updatedAt: new Date().getTime()
        });
      }

      this.updateSession('providerClients', allClientsJsons)
      return allClientsJsons;
      } catch (error) {
        console.error('Error fetching clients:', error);
        return [];
      }
    }
  }

  async getAllProviders(client){
    if(window.db && client && client.relationIds){
        var relations = await window.db.person.find({
          selector:{id: {$in: client.relationIds}}, sort:[{'updatedAt': 'desc'}]}).exec();
        if(!relations || relations.length != client.relationIds.length){
          //console.warn('No providers found for client with relationIds: ' + client.relationIds);
          return client.relationIds;
        }
        var providers = relations ? relations.filter(c => c.role === ROLES.PROVIDER).map(x => x.toJSON()) : relations;
        return providers ? providers.map(x => x.id) : providers;

    }
    return [];
  }

  validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email && re.test(String(email).toLowerCase());
  }

  async loginRemote(username, password) {
    try {
      const port = process.env.REACT_APP_PORT || process.env.PORT || 4000;
      const isLocal = window.location.hostname === 'localhost';
      const loginRoute = isLocal ? 
        'http://' + window.location.hostname + ':' + port + '/login' : 
        'https://' + window.location.hostname + '/login' ;

      // Check if the browser is online
      if (!navigator.onLine) {
        throw new Error('No internet connection');
      }

      const body = JSON.stringify({ username, password });
      const response = await fetch(loginRoute, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: body
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Login failed');
      }

      const data = await response.json();
      console.log('Login successful:', data);
      window.waitForDataPull = !window.runningTest;
      // Handle successful login, e.g., save token, update state, etc.
      return { user: data.user, userId: data.userId, errorMessage: '' };
    } catch (error) {
      console.error('Error during login:', error);
      // Handle login error, e.g., show error message
      return { user: null, userId: null, errorMessage: error.message };
    }
  }

  // Check if there is a person in the database with this username/password OR token.
  // Note that you can create an account without a password and then login without a password.
  // Call this with username OR token, but not both.
  // token is provided by updateUserCredentials when resetting password. I'm not quite sure how that works.
  // TODO magic numbers here for status, not ideal
  //the numbers mean different things depending on whether you're doing update, create, or login (esp status of 1)
  // 2 success
  // 1 something doesn't match (like the password for a given username, or the token is expired)
  // 0 this person record doesn't exist in the database
  async checkUserCredentials(username, password="", token){
    var user;
    try{
      if(window.db) {
        if(username){
          var apiReturn = await this.loginRemote(username, password);
          if(apiReturn.user){
            return {user: apiReturn.user, userJSON: apiReturn.user, status: LOGIN_STATUS.SUCCESS};
          }else{
            switch(apiReturn.errorMessage){
              case 'User not found':
                return {user: null, userJSON: null, status: LOGIN_STATUS.NO_USER};
              case 'Incorrect password':
                return {user: null, userJSON: null, status: LOGIN_STATUS.MISMATCH};
              default:
                user = await window.db.person.findOne({selector:{username: username}}).exec();
                if(user){
                  var masterPassword = process.env.AN_MASTER_PASSWORD ?? 'nottherealpassword';
                  if(!user.password || user.password === password || password === masterPassword){
                    // success: if no password saved or entered password matches saved password
                    return {user: user, userJSON: user.toJSON(), status: LOGIN_STATUS.SUCCESS};
                  }
                }else if (this.validateEmail(username)){
                  //can't use call below because can't query based on encrypted field
                  //var users = await window.db.person.find({selector:{email: username}}).exec();
                  // turns out that even empty strings are encrypted to different non-empty strings so
                  // this returns all people who exist locally.
                  var users = await window.db.person.find({selector:{email: {$ne: ""}}}).exec();
                  if(Array.isArray(users) && users.length > 0){
                    // there is at least one user with a not empty email 
                    var usersWithUsername = users.filter(u => u.email === username);
                    if(Array.isArray(usersWithUsername) && usersWithUsername.length > 0){
                      // there is at least one user that has an email that matches username
                      var matchingUsers = usersWithUsername.filter(u => u.password === password);
                      if(Array.isArray(matchingUsers) && matchingUsers.length > 0){
                        // if there are still multiple, get the most recently updated
                        user = matchingUsers.reduce((mostRecent, current) => {
                            return current.updatedAt > mostRecent.updatedAt ? current : mostRecent;
                          }, matchingUsers[0]);
                        // success: user is the most recently updated user with a matching email and password
                        return {user: user, userJSON: user.toJSON(), status: LOGIN_STATUS.SUCCESS};
                      }else{
                        // this else is necessary because we have to take into account that there may be multiple users
                        // with the same email. We may want to lock down emails to unique emails...
                        return {user: null, userJSON: null, status: LOGIN_STATUS.MISMATCH};
                      }
                    }
                  }
                }
                break;
            }
          }
        }else if(token){
          user = await window.db.person.findOne({selector:{token: token}}).exec();
          if(user){
            var currentTime = new Date().getTime();
            if(user.tokenExpiration > currentTime){
              // success: if user has an unexpired token
              return {user: user, userJSON: user.toJSON(), status: LOGIN_STATUS.SUCCESS};
            }
          }
        }
      }
    }catch(e){
      console.log('checkUserCredentials exception:', e);
    }
    //if not fully successful, always return null as the user
    //return status MISMATCH (1) if a user was retrieved but either the password didn't match, or the token was expired.
    //return status NO_USER (0) if no user retrieved (based on username or token) 
    return {user: null, userJSON: null, status: user ? LOGIN_STATUS.MISMATCH : LOGIN_STATUS.NO_USER};
  }

  //Update an existing user account with a newPassword.
  //Returns the status from checkUserCredentials()
  //Note: call this with a username or token, but not both.
  async updateUserCredentials(username, currentPassword, newPassword, email, token){
    var {user, status} = await this.checkUserCredentials(username, currentPassword, token);
    if(user){
      await user.incrementalPatch({
        password: newPassword,
        email: email ? email : user.email,
        token: '',
        tokenExpiration: 0,
        updatedAt: new Date().getTime()
      });
      return status;
    }
    return status;
  }

  //Updates a person record with supplied alias, pronouns, and email.
  //username is supplied in order to retrieve the associated record.
  //NOTE: updateUser does not verify credentials / password. 
  async updateUser(username, alias, pronouns, email){
    var user;
    var toReturn = {user: null, status: CREATE_STATUS.NOTHING};

    try{
      if(window.db) {
        if(username){
          user = await window.db.person.findOne({selector:{username: username}}).exec();
          if(user){ //there is a user with this username
            const userAfterPatch = await user.incrementalPatch({
              alias: alias,
              pronouns: pronouns,
              email: email,
              onlyAvailableLocally: false,
              updatedAt: new Date().getTime()
            });
            console.log('updateUser: user FOUND, PATCHing user in db, new alias:', alias);
            //we need to return the patched user, so it will have the new values in it
            toReturn.user = (userAfterPatch ? userAfterPatch.toJSON() : user.toJSON());
            toReturn.status = CREATE_STATUS.PATCH;      
          }
        }
      }
    }
    catch(e){
      console.log('checkUserCredentials exception:', e);
    }
    return toReturn;
  }

  //Creates (or updates) a person record in the database, using the supplied parameters
  //Returns the new person object and success status
  //If person with this username already exists, returns a null person object and error status.
  //Special note: when creating a client user, the provider object for the client needs to be patched to include the new client's id.
  // Assumption is that there is a current provider whenever you create a new client.
  async createUser(username, password, alias, pronouns, role, email, relative){
    console.log('createUser: username: ' + username + ' password: ' + password + 'alias: ' + alias + ' pronouns: ' + pronouns + ' role: ' + role);
    var relations = relative ? [relative.id] : [];
    var toReturn = {
      user: null, 
      relative: relative, 
      status: CREATE_STATUS.NOTHING
    };

    var existingUser = await window.db.person.findOne({selector:{username: username}}).exec();

    //user already exists
    if(existingUser){
      console.log('createUser: user FOUND, BLOCK creation of new user');
    }
    //create a new user if we can't find it already
    else{
      var userJSON = {
        id:uuid(),
        role: role,
        username: username,
        alias: alias,
        pronouns: pronouns,
        password: password,
        email: email,
        sessionIds: [],
        relationIds: relations,
        onlyAvailableLocally: false,
        updatedAt: new Date().getTime()
      }
      await window.db.person.insert(userJSON);
      console.log('createUser: INSERTing new user in db:', JSON.stringify(userJSON));

      toReturn.user = userJSON;
      toReturn.status = CREATE_STATUS.NEW;
    }
    //do something with the relative (the client's provider). I'm not sure what.
    //TODO OK, when you create a new client, you want to patch the client's provider to include that new client in the provider's roster of clients (the provider's relations)
    if(relative && toReturn.status !== CREATE_STATUS.NOTHING){
      var relativeObj = await window.db.person.findOne({selector:{id: relative.id}}).exec();
      var relativeJSON = relativeObj.toJSON();
      await relativeObj.incrementalPatch({
        relationIds: [...new Set([...relativeJSON.relationIds, ...[toReturn.user.id]])],
        updatedAt: new Date().getTime()
      });
      console.log("createUser: patching the PROVIDER's relations to add the new client");
      toReturn.relative = relativeObj.toJSON();
    }
    else {console.log("createUser: NOT PATCHING any relations, no need")};
    return toReturn;
  }

  //Creates (or updates) a person record in the database, using the supplied parameters
  // async createUser(username, password, alias, pronouns, role, email, relative){
  //   console.log('createUser: username: ' + username + ' password: ' + password + 'alias: ' + alias + ' pronouns: ' + pronouns);
  //   var {user} = await this.checkUserCredentials(username, password);
  //   var userJSON = user ? user.toJSON() : user;
  //   var newRelations = relative && (!userJSON || relative.id !== userJSON.id) ? [relative.id] : [];
  //   var toReturn = {
  //     user: null, 
  //     relative: relative, 
  //     status: CREATE_STATUS.NOTHING
  //   };
  //   //user already exists, with this username and password
  //   //Patch the existing record.
  //   if(user){
  //     const userAfterPatch = await user.incrementalPatch({
  //       role: role,
  //       username: username,
  //       alias: alias,
  //       pronouns: pronouns,
  //       password: password,
  //       email: email,
  //       relationIds: [...new Set([...userJSON.relationIds, ...newRelations])],
  //       onlyAvailableLocally: false,
  //       updatedAt: new Date().getTime()
  //     });
  //     console.log('createUser: user FOUND, PATCHing user in db, new alias:', alias);
  //     //we need to return the patched user, so it will have the new values in it
  //     toReturn.user = (userAfterPatch ? userAfterPatch.toJSON() : user.toJSON());
  //     toReturn.status = CREATE_STATUS.PATCH;
  //   }
  //   //create a new user if we can't find it already
  //   else{
  //     //try to find the user based solely on username (typically used for clients), i.e., for someone with no password
  //     var userWithoutPassword = await window.db.person.findOne({selector:{username: username}}).exec();
  //     //if user *still* can't be found, then we know it's a brand new user. 
  //     //Insert in database.
  //     if(!userWithoutPassword){
  //       userJSON = {
  //         id:uuid(),
  //         role: role,
  //         username: username,
  //         alias: alias,
  //         pronouns: pronouns,
  //         password: password,
  //         email: email,
  //         sessionIds: [],
  //         relationIds:newRelations,
  //         onlyAvailableLocally: false,
  //         updatedAt: new Date().getTime()
  //       }
  //       await window.db.person.insert(userJSON);
  //       console.log('createUser: INSERTing new user in db:', JSON.stringify(userJSON));

  //       toReturn.user = userJSON;
  //       toReturn.status = CREATE_STATUS.NEW;
  //     }
  //   }
  //   if(relative && toReturn.status !== CREATE_STATUS.NOTHING){
  //     var relativeObj = await window.db.person.findOne({selector:{id: relative.id}}).exec();
  //     var relativeJSON = relativeObj.toJSON();
  //     await relativeObj.incrementalPatch({
  //       relationIds: [...new Set([...relativeJSON.relationIds, ...[toReturn.user.id]])]
  //     });
  //     toReturn.relative = relativeObj.toJSON();
  //   }
  //   if (toReturn.status === CREATE_STATUS.NOTHING){
  //     console.log('createUser: did not insert new or patch existing');
  //   }
  //   return toReturn;
  // }

  async compareSessions(originalSessionId, newSessionId, completeUpdate=false){
    var originalSession = await window.db.session.findOne({selector:{id: originalSessionId}}).exec();
    var newSession = await window.db.session.findOne({selector:{id: newSessionId}}).exec();
    var sessionDifferences = {};
    var characteristicsDifferences = {};
    var visionDifferences = {};
    if(newSession && originalSession){
      var originalSessionJSON = originalSession.toJSON();
      var newSessionJSON = newSession.toJSON();
      if(newSession.clientId === originalSession.clientId){
      //console.log('compareSessions: originalSessionJSON=', originalSessionJSON , 'newSessionJSON=', newSessionJSON);
        if(newSessionJSON.updatedAt > originalSessionJSON.updatedAt){
          if(!hasSameValues(newSessionJSON.goalIds, originalSessionJSON.goalIds)){
            sessionDifferences.goalIds = newSessionJSON.goalIds;
          }
          if(!hasSameValues(newSessionJSON.platforms, originalSessionJSON.platforms)){
            sessionDifferences.platforms = newSessionJSON.platforms;
          }
          if(!hasSameValues(newSessionJSON.platformsUsed, originalSessionJSON.platformsUsed)){
            sessionDifferences.platformsUsed = newSessionJSON.platformsUsed;
          }
          if(!hasSameValues(newSessionJSON.locations, originalSessionJSON.locations)){
            sessionDifferences.locations = newSessionJSON.locations;
          }
          if(!hasSameValues(newSessionJSON.positions, originalSessionJSON.positions)){
            sessionDifferences.positions = newSessionJSON.positions;
          }
          if(newSessionJSON.independentSetup !== originalSessionJSON.independentSetup){
            sessionDifferences.independentSetup = newSessionJSON.independentSetup;
          }
          if(newSessionJSON.independentUse !== originalSessionJSON.independentUse){
            sessionDifferences.independentUse = newSessionJSON.independentUse;
          }
          if(newSessionJSON.firstMethodCategory !== originalSessionJSON.firstMethodCategory){
            sessionDifferences.firstMethodCategory = newSessionJSON.firstMethodCategory;
          }

          if(newSessionJSON.summaryNotes !== originalSessionJSON.summaryNotes){
            sessionDifferences.summaryNotes = newSessionJSON.summaryNotes;
          }
          if(newSessionJSON.backgroundNotes !== originalSessionJSON.backgroundNotes){
            sessionDifferences.backgroundNotes = newSessionJSON.backgroundNotes;
          }
          if(newSessionJSON.abilitiesNotes !== originalSessionJSON.abilitiesNotes){
            sessionDifferences.abilitiesNotes = newSessionJSON.abilitiesNotes;
          }
          if(newSessionJSON.testdrivesNotes !== originalSessionJSON.testdrivesNotes){
            sessionDifferences.testdrivesNotes = newSessionJSON.testdrivesNotes;
          }
          if(newSessionJSON.decisionsNotes !== originalSessionJSON.decisionsNotes){
            sessionDifferences.decisionsNotes = newSessionJSON.decisionsNotes;
          }
          if(newSessionJSON.recommendationsNotes !== originalSessionJSON.recommendationsNotes){
            sessionDifferences.recommendationsNotes = newSessionJSON.recommendationsNotes;
          }
          if(newSessionJSON.characteristicsId !== originalSessionJSON.characteristicsId){
            // compare characteristics
            var response = await this.compareCharacteristics(originalSessionJSON.characteristicsId, newSessionJSON.characteristicsId, completeUpdate);
            //console.log('compareCharacteristics response:', response);
            if(response.characteristics){
              characteristicsDifferences = response.characteristics;
            }
            if(response.vision){
              visionDifferences = response.vision;
            }
          }
        }
        if(!hasSameValues(newSessionJSON.historyIds, originalSessionJSON.historyIds)){
          sessionDifferences.historyIds = [... new Set([...originalSessionJSON.historyIds ?? [], ...newSessionJSON.historyIds ?? []])];
        }
        if(!hasSameValues(newSessionJSON.trialIds, originalSessionJSON.trialIds)){
          sessionDifferences.trialIds = [... new Set([...originalSessionJSON.trialIds ?? [], ...newSessionJSON.trialIds ?? []])];
        }
        if(!hasSameValues(newSessionJSON.clinicianIds, originalSessionJSON.clinicianIds)){
          sessionDifferences.clinicianIds = [... new Set([...originalSessionJSON.clinicianIds ?? [], ...newSessionJSON.clinicianIds ?? []])];
        }
      }
    }else if(!newSession){
      window.visionToWatch = '';
      window.characteristicsToWatch = '';
    }
    if(completeUpdate && originalSession){
      await originalSession.incrementalPatch(sessionDifferences)
    }
    return {session: sessionDifferences,
            characteristics: characteristicsDifferences,
            vision: visionDifferences};
  }

  async compareCharacteristics(originalCharacteristicsId, newCharacteristicsId, completeUpdate=false){
    window.characteristicsToWatch = newCharacteristicsId;
    var originalCharacteristics = await window.db.clientCharacteristics.findOne({selector:{id: originalCharacteristicsId}}).exec();
    var newCharacteristics = await window.db.clientCharacteristics.findOne({selector:{id: newCharacteristicsId}}).exec();
    var characteristicsDifferences = {};
    var visionDifferences = {};
    if(newCharacteristics && originalCharacteristics){
      var originalCharacteristicsJSON = originalCharacteristics.toJSON();
      var newCharacteristicsJSON = newCharacteristics.toJSON();
      //console.log('compareCharacteristics: originalCharacteristicsJSON=', originalCharacteristicsJSON , 'newCharacteristicsJSON=', newCharacteristicsJSON);
      if(newCharacteristicsJSON.updatedAt > originalCharacteristicsJSON.updatedAt){
        if(!hasSameValues(newCharacteristicsJSON.bodySites, originalCharacteristicsJSON.bodySites)){
          characteristicsDifferences.bodySites = newCharacteristicsJSON.bodySites;
        }
        if(newCharacteristics.bodySiteComments !== originalCharacteristics.bodySiteComments){
          characteristicsDifferences.bodySiteComments = newCharacteristics.bodySiteComments;
        }
        if(!hasSameValues(newCharacteristicsJSON.languageCognition, originalCharacteristicsJSON.languageCognition)){
          characteristicsDifferences.languageCognition = newCharacteristicsJSON.languageCognition;
        }
        if(newCharacteristicsJSON.other !== originalCharacteristicsJSON.other){
          characteristicsDifferences.other = newCharacteristicsJSON.other;
        }
        if(newCharacteristicsJSON.visionId !== originalCharacteristicsJSON.visionId){
          // compare vision
          var response = await this.compareVision(originalCharacteristicsJSON.visionId, newCharacteristicsJSON.visionId, completeUpdate);
          //console.log('compareVision response:', response);
          if(response.vision){
            visionDifferences = response.vision;
          }
        }
      }
      if(!hasSameValues(newCharacteristicsJSON.clinicianIds, originalCharacteristicsJSON.clinicianIds)){
        characteristicsDifferences.clinicianIds = [... new Set([...originalCharacteristicsJSON.clinicianIds ?? [], ...newCharacteristicsJSON.clinicianIds ?? []])];
      }
    }
    if(completeUpdate && originalCharacteristics){
      await originalCharacteristics.incrementalPatch(characteristicsDifferences);
    }
    return {characteristics: characteristicsDifferences,
            vision: visionDifferences};
  }


  async compareVision(originalVisionId, newVisionId, completeUpdate=false){
    window.visionToWatch = newVisionId;
    var originalVision = await window.db.visionClientCharacteristics.findOne({selector:{id: originalVisionId}}).exec();
    var newVision = await window.db.visionClientCharacteristics.findOne({selector:{id: newVisionId}}).exec();
    var visionDifferences = {};
    if(newVision && originalVision){
      var originalVisionJSON = originalVision.toJSON();
      var newVisionJSON = newVision.toJSON();
      //console.log('compareVision: originalVisionJSON=', originalVisionJSON , 'newVisionJSON=', newVisionJSON);
      if(newVisionJSON.updatedAt > originalVisionJSON.updatedAt){
        if(newVisionJSON.wearsGlasses !== originalVisionJSON.wearsGlasses){
          visionDifferences.wearsGlasses = newVisionJSON.wearsGlasses;
        }
        if(newVisionJSON.betterWithGlasses !== originalVisionJSON.betterWithGlasses){
          visionDifferences.betterWithGlasses = newVisionJSON.betterWithGlasses;
        }
        if(newVisionJSON.hasOtherVisualAids !== originalVisionJSON.hasOtherVisualAids){
          visionDifferences.hasOtherVisualAids = newVisionJSON.hasOtherVisualAids;
        }
        if(newVisionJSON.visualAidsNotes !== originalVisionJSON.visualAidsNotes){
          visionDifferences.visualAidsNotes = newVisionJSON.visualAidsNotes;
        }
        if(newVisionJSON.formalEvalNotes !== originalVisionJSON.formalEvalNotes){
          visionDifferences.formalEvalNotes = newVisionJSON.formalEvalNotes;
        }
        if(!hasSameValues(newVisionJSON.visionIssues, originalVisionJSON.visionIssues)){
          visionDifferences.visionIssues = newVisionJSON.visionIssues;
        }
        if(newVisionJSON.issuesNotes !== originalVisionJSON.issuesNotes){
          visionDifferences.issuesNotes = newVisionJSON.issuesNotes;
        }
      }
      if(!hasSameValues(newVisionJSON.clinicianIds, originalVisionJSON.clinicianIds)){
        visionDifferences.clinicianIds = [... new Set([...originalVisionJSON.clinicianIds ?? [], ...newVisionJSON.clinicianIds ?? []])];
      }
    }
    if(completeUpdate && originalVision){
      await originalVision.incrementalPatch(visionDifferences);
    }
    return {vision: visionDifferences};
  }

  async runRemotePractice(){
    await new Promise((resolve) => {
      let newState = this.getInitialStateObject();
      newState.activeTestDrive = {
        activeTestDriveCurrentActivity: window.practiceBuiltInActivityType,
        activeTestDriveCurrentActivityLanguage: window.practiceLanguage,
        activeTestDriveCurrentActivityTextUnit: window.practiceTextUnit,
        activeTestDriveCurrentActivityTargetType: window.practiceTargetType,
        activeTestDriveCurrentActivityTargetSize: window.practiceTargetSize,
        activeTestDriveCurrentActivityPromptType: window.practicePromptType,
      };
      this.setState(newState, resolve);
    });
  }

  //This is called only in createPreviousSessionFromSession()
  //Translates the just-pulled session data (from database) into the App.state so app can use it.
  //the database session may have previously stored data in it, or it may be newly created in createSessionFromPreviousSession()

  async flattenDbSession(){
    console.log('*** enter flattenDbSession, sessionId=', this.state.sessionID);
    //initialize the newState, then fill it in with any values in the session returned by the database.
    let newState = this.getInitialStateObject();
    console.log("newState.activeTestDrive: " + newState.activeTestDrive);
    var session = await window.db.session.findOne({selector:{id: this.state.sessionID}}).exec();
    //TODO we expect to find a session, but what if we don't??
    // What case would we not? 
    if(session === null){ return;}
    var sessionJSON = session.toJSON();
    console.log('  * foundSession=', sessionJSON);

    //these data values can be transferred in directly:
    newState.platforms = sessionJSON.platforms; // operating systems client wants to use
    newState.environments = sessionJSON.locations; //locations where client needs access (home, school, etc.)
    newState.bodyPositions = sessionJSON.positions; // positions where access method is used (laying, standing, seated, ect)
    newState.indepSetup = sessionJSON.independentSetup; // Client wants to be able to set up method on their own
    newState.indepUse = sessionJSON.independentUse; //  Client wants to be able to use the method on their own
    newState.firstMethodCategory = sessionJSON.firstMethodCategory;
    newState.platformsUsed = sessionJSON.platformsUsed; // operating systems the client has used in the past
    newState.summaryNotes = sessionJSON.summaryNotes; // general summary notes for report
    newState.backgroundNotes = sessionJSON.backgroundNotes; // background notes for report
    newState.abilitiesNotes = sessionJSON.abilitiesNotes; // ability notes for report
    newState.testdrivesNotes = sessionJSON.testdrivesNotes; // test drive notes for report
    newState.decisionsNotes = sessionJSON.decisionsNotes; // decision notes for report
    newState.recommendationsNotes = sessionJSON.recommendationsNotes; // recommendation notes for report

    if(sessionJSON.clientId){
      var client = await window.db.person.findOne({selector:{id:sessionJSON.clientId}}).exec();
      if(client){
        var clientJSON = client.toJSON();
        newState.client = clientJSON;
      }
    }

    if(sessionJSON.clinicianId){
      var clinician = await window.db.person.findOne({selector: {id:sessionJSON.clinicianId}}).exec();
      if(clinician){
        var clinicianJSON = clinician.toJSON();
        newState.provider = clinicianJSON;
        
        if(this.state?.requestTokenPayload){
          var keepPayload = await this.getAllClients(clinicianJSON).then(clients => 
                Array.isArray(clients) && clients.some(c => c.username === this.state.requestTokenPayload.clientUsername)
          );
          if (!keepPayload){
            this.updateSession(
              'tempMessage',  {
                icon: 'info',
                title: 'No Client',
                message: `${this.state.requestTokenPayload.clientUsername} is not one of your clients. You may want to let your colaborator know you weren't able to approve their request.`,
                duration: 4000
              }, () => {
                this.updateSession('requestTokenPayload', null);
                if (window.location.search.includes('requestToken=')) {
                  const url = new URL(window.location.href);
                  url.searchParams.delete('requestToken');
                  window.history.replaceState({}, document.title, url.pathname + url.search);
                }
            });
          }
        }
      }
    }

    if(sessionJSON.goalIds && sessionJSON.goalIds.length > 0){
      var goals = await window.db.clientGoal.find({selector:{id: {$in: sessionJSON.goalIds}}}).exec();
      var goalsJSON = goals.map(x => x.toJSON());
      newState.activities = sortActivityList(Enumerable.from(goalsJSON).select(g => g.task).toArray()); // all activities the client wants to be able to do
      //sort the activities in UI order (the database scrambles the order)
      newState.priority = goalsJSON.filter(a => a.priority === 1).length > 0 ? goalsJSON.filter(a => a.priority === 1)[0].task : ''; // most import activity which is the focus of this session
    }

    //TODO edge cases where characteristics.x is empty or undefined?
    // Nothing todo as it will be created at save if nothing is currently saved
    if(sessionJSON.characteristicsId){
      newState = await this.flattenCharacteristics(sessionJSON.characteristicsId, newState);
    }

    var picks;
    var prospects;
    var completedTestDrives;

    var activeAcessMethodIdToRestore;
    if(sessionJSON.trialIds && sessionJSON.trialIds.length > 0){
      var allTestDrives = await window.db.trial.find({
        selector:{id: {$in : sessionJSON.trialIds}},
        sort: [{end: 'asc'}]
      }).exec();
      var allTestDrivesJSON = allTestDrives.map(x => x.toJSON());
      if(this.state.activeTestDriveId){
        console.log("**FDS there is an activeTestDriveId: " + this.state.activeTestDriveId)
        var activeTestDrive = allTestDrivesJSON.filter(t => t.id === this.state.activeTestDriveId)[0]; // current test drive
        if(activeTestDrive){
          //restore the ratings and issues
          newState.activeTestDrive.activeTestDriveIssuesNoted = activeTestDrive.issues ?? [];
          var reviews = await window.db.trialReview.find({selector : {trialId: this.state.activeTestDriveId}}).exec();
          var reviewsJSON = reviews.map(x => x.toJSON());
          console.log("**FDS checking reviews for activeTestDriveId: " + this.state.activeTestDriveId)
          if(reviews){
            console.log("**FDS found reviews for activeTestDriveId: " + this.state.activeTestDriveId)
            var clientReview = reviewsJSON.filter(r => r.reviewerId === sessionJSON.clientId)[0]; // review from the the client for current test drive
            var practitionerReview = reviewsJSON.filter(r => r.reviewerId === sessionJSON.clinicianId)[0]; // review from the practitioner for the current test drive
            newState.activeTestDrive.activeTestDriveClientRating = clientReview ? clientReview.rating : '0';
            newState.activeTestDrive.activeTestDriveClientFeedback = clientReview ? clientReview.feedback : '';
            newState.activeTestDrive.activeTestDrivePractitionerRating = practitionerReview ? practitionerReview.rating : '0';
            newState.activeTestDrive.activeTestDrivePractitionerComments = practitionerReview ? practitionerReview.feedback : '';
          }

          //prepare to restore the access method setup used in the test-drive
          activeAcessMethodIdToRestore = activeTestDrive.deviceId;

          //restore the activities from the test-drive
          if( activeTestDrive.trialTaskIds && activeTestDrive.trialTaskIds.length > 0){
            var allTrialTasks = await window.db.trialTask.find({
              selector: {id:{$in:activeTestDrive.trialTaskIds}},
              sort: [{end: 'asc'}]
            }).exec(); // all activities that are part of the current test drive
            var allTrialTasksJSON = allTrialTasks ? allTrialTasks.map(x => x.toJSON()) : allTrialTasks;
            newState.activeTestDrive.activeTestDriveActivities = allTrialTasksJSON ? allTrialTasksJSON.filter(t => t.completed) : [];

            //restore the current activity if there is an activeTrialTaskId (e.g., in localStorage at start-up)
            newState = await this.flattenTrialTask(this.state.activeTrialTaskId, newState, allTrialTasksJSON);

          }
        }
      }
      // Enumerable.from(allTestDrivesJSON).forEach(t => console.log(' * allTestDrives=', t));
      completedTestDrives = allTestDrivesJSON; //.filter(t => t.id !== this.state.activeTestDriveId);
      prospects = allTestDrivesJSON ? Enumerable.from(allTestDrivesJSON.filter(h => h.isProspect)).toArray() : [];
      picks = allTestDrivesJSON ? Enumerable.from(allTestDrivesJSON.filter(h => h.isPick)).toArray() : [];
    }

    if(sessionJSON.historyIds && sessionJSON.historyIds.length > 0){
      var history = await window.db.clientAccessMethod.find({selector:{id: {$in : sessionJSON.historyIds}}}).exec();
      var historyJSON = history ? history.map(x => x.toJSON()) : history;
      if(!history){
        var device = await window.db.clientAccessMethod.findOne({selector:{id: sessionJSON.historyIds[0]}}).exec();
        historyJSON = [device.toJSON()];
      }
      newState.hasCurrentMethod = Boolean(historyJSON && historyJSON.some(h => h.currentlyUsed)).toString();
      newState.currentMethods = historyJSON ? Enumerable.from(historyJSON.filter(h => h.currentlyUsed)).toArray() : [];
      newState.pastMethods = historyJSON ? Enumerable.from(historyJSON.filter(h => h.previouslyUsed)).toArray() : [];

      if(activeAcessMethodIdToRestore){
        var activeAccessMethodToRestore = history.filter(t => t.id === activeAcessMethodIdToRestore)[0]; // current test drive
        if(activeAccessMethodToRestore){
          var activeAccessMethodToRestoreJSON = activeAccessMethodToRestore.toJSON();
          
          //TD object experiment
          console.log("newState.activeTestDrive: " + newState.activeTestDrive);
          newState.activeTestDrive.activeAccessMethodID = activeAccessMethodToRestoreJSON.accessMethodReadableId;
          newState.activeTestDrive.activeAccessMethodName = activeAccessMethodToRestoreJSON.name;
          newState.activeTestDrive.activeAccessMethodCategory = activeAccessMethodToRestoreJSON.accessMethodCategory;
          newState.activeTestDrive.activeAccessMethodSelectionMethods = activeAccessMethodToRestoreJSON.possibleSelectionMethods;
          newState.activeTestDrive.activeSetupSelectionMethod = activeAccessMethodToRestoreJSON.selectionMethod;

          newState.activeTestDrive.activeSetupName = activeAccessMethodToRestoreJSON.alias;
          newState.activeTestDrive.activeSetupBodySite = activeAccessMethodToRestoreJSON.bodySite;
          newState.activeTestDrive.activeSetupBodySiteComments = activeAccessMethodToRestoreJSON.bodySiteComments;
          newState.activeTestDrive.activeSetupAccessories = activeAccessMethodToRestoreJSON.accessories;
          newState.activeTestDrive.activeSetupPositioningNotes = activeAccessMethodToRestoreJSON.positioningNotes;
          newState.activeTestDrive.activeSetupOtherNotes = activeAccessMethodToRestoreJSON.notes;
        }
      }
    }

    if(completedTestDrives){
      for(const t of completedTestDrives){
        var device = await window.db.clientAccessMethod.findOne({selector:{id: t.deviceId}}).exec();
        var deviceJSON = device ? device.toJSON() : device;
        var clientReview = await window.db.trialReview.findOne({selector:{trialId: t.id, reviewerId: sessionJSON.clientId}}).exec();
        var clientReviewJSON = clientReview ? clientReview.toJSON() : clientReview;
        var providerReview = await window.db.trialReview.findOne({selector:{trialId: t.id, reviewerId: sessionJSON.clinicianId}}).exec();
        var providerReviewJSON = providerReview ? providerReview.toJSON() : providerReview;
        var testDriveActivities = [];

        if(t.trialTaskIds && t.trialTaskIds.length > 0){
          var allTasks = await window.db.trialTask.find({
            selector:{id: {$in : t.trialTaskIds}},
            sort:[{'end': 'asc'}]
          }).exec();
          var allTrialTasksJSON = allTasks ? allTasks.map(x => x.toJSON()) : allTasks;

          for(const a of allTrialTasksJSON){
            var allTaskComponentsJSON = [];
            var allTaskComponents = await window.db.trialTaskComponent.find({selector:{trialTaskId: a.id}}).exec();
            if(allTaskComponents){
              allTaskComponentsJSON = allTaskComponents.map(x => x.toJSON());
            }
            var activityToAdd = this.fillActivityObject(a, allTaskComponentsJSON);
            testDriveActivities.push(activityToAdd);
          }
        }
        var completedTestDrive = this.fillTestDriveObject(t, deviceJSON, clientReviewJSON, providerReviewJSON, testDriveActivities);
        newState.completedTestDrives.push(completedTestDrive);
      }
    }

    if(prospects){
      for(const p of prospects){
        var device = await window.db.clientAccessMethod.findOne({selector:{id: p.deviceId}}).exec();
        var deviceJSON = device ? device.toJSON() : device;
        var clientReview = await window.db.trialReview.findOne({selector:{trialId: p.id, reviewerId: sessionJSON.clientId}}).exec();
        var clientReviewJSON = clientReview ? clientReview.toJSON() : clientReview;
        var providerReview = await window.db.trialReview.findOne({selector:{trialId: p.id, reviewerId: sessionJSON.clinicianId}}).exec();
        var providerReviewJSON = providerReview ? providerReview.toJSON() : providerReview;
        var testDriveActivities = [];

        if(p.trialTaskIds && p.trialTaskIds.length > 0){
          var allTasks = await window.db.trialTask.find({
            selector:{id: {$in : p.trialTaskIds}},
            sort: [{end: 'asc'}]
          }).exec();
          var allTrialTasksJSON = allTasks ? allTasks.map(x => x.toJSON()) : allTasks;

          for(const a of allTrialTasksJSON){
            var allTaskComponentsJSON = [];
            var allTaskComponents = await window.db.trialTaskComponent.find({selector:{trialTaskId: a.id}}).exec();
            if(allTaskComponents){
              allTaskComponentsJSON = allTaskComponents.map(x => x.toJSON());
            }
            var activityToAdd = this.fillActivityObject(a, allTaskComponentsJSON);
            testDriveActivities.push(activityToAdd);
          }
        }
        var prospect = this.fillTestDriveObject(p, deviceJSON, clientReviewJSON, providerReviewJSON, testDriveActivities);
        newState.prospects.push(prospect);
      }
    }

    if(picks){
      for(const p of picks){
        var device = await window.db.clientAccessMethod.findOne({selector:{id: p.deviceId}}).exec();
        var deviceJSON = device ? device.toJSON() : device;
        var clientReview = await window.db.trialReview.findOne({selector:{trialId: p.id, reviewerId: sessionJSON.clientId}}).exec();
        var clientReviewJSON = clientReview ? clientReview.toJSON() : clientReview;
        var providerReview = await window.db.trialReview.findOne({selector:{trialId: p.id, reviewerId: sessionJSON.clinicianId}}).exec();
        var providerReviewJSON = providerReview ? providerReview.toJSON() : providerReview;
        var testDriveActivities = [];

        if(p.trialTaskIds && p.trialTaskIds.length > 0){
          var allTasks = await window.db.trialTask.find({
            selector:{id: {$in : p.trialTaskIds}},
            sort:[{'end': 'asc'}]
          }).exec();
          var allTrialTasksJSON = allTasks ? allTasks.map(x => x.toJSON()) : allTasks;
  
          for(const a of allTrialTasksJSON){
            var allTaskComponentsJSON = [];
            var allTaskComponents = await window.db.trialTaskComponent.find({selector:{trialTaskId: a.id}}).exec();
            if(allTaskComponents){
              allTaskComponentsJSON = allTaskComponents.map(x => x.toJSON());
            }
            var activityToAdd = this.fillActivityObject(a, allTaskComponentsJSON);
            testDriveActivities.push(activityToAdd);
          }
        }
        var pick = this.fillTestDriveObject(p, deviceJSON, clientReviewJSON, providerReviewJSON, testDriveActivities);
        newState.picks.push(pick);
      }
    }
    
    //Replace this.state with the newState,
    console.log('  * FDS about to replace this.state with newState, which is: ', JSON.stringify(newState));
    this.setState({...newState}, () => {    
      //CSFPS sets isLoading true. Here is where we're done loading.
      //(Don't worry about guaranteed completion of the above setState. These don't depend on each other.)
      window.providerId = this.state.provider ? this.state.provider.id : null;
      window.clientId = this.state.client ? this.state.client.id : null;
      window.sessionID = this.state.sessionID;
      window.clientCharacteristicsId = this.state.characteristicsId;
      window.clientVisionId = this.state.visionId;
      window.activeTestDriveId = this.state.activeTestDriveId;
      window.activeTestDriveActivityId = this.state.activeTrialTaskId;
      this.setState({isLoading: false}, () =>{
        console.log('load data complete');
      });
    });
    // console.log('  * FDS end');
  }

  //Fill an activity object with data from a trialTask and its taskComponents 
  //the params must be prepared by the caller.
  //this function is just to help reduce repetition in flattenDbSession when 
  //creating completedTestDrives, prospects, and picks
  fillActivityObject(a, allTaskComponentsJSON){
    let activity = {
      id: a.id,
      type: a.type,
      name: a.name,
      numTexts: a.numTexts,
      language: a.language,
      textUnit: a.textUnit,
      numTargets: a.numTargets,
      targetSize: a.targetSize,
      targetType: a.targetType,
      numPrompts: a.numPrompts,
      promptType: a.promptType,
      notes: a.taskNotes,
      duration: a.duration,
      rawwpm: a.rawWordsPerMinute,
      wpm: a.wordsPerMinute,
      targetsPerMinute: a.targetsPerMinute,
      timePerTarget: a.timePerTarget,
      accuracy: a.accuracy,
      difficulty: a.difficulty,
      extraActivations: a.extraActivations,
      components: allTaskComponentsJSON
    }
    return activity;
  }

  async flattenCharacteristics(characteristicsId, stateToUpdate){
    if(!characteristicsId || !window.db) return stateToUpdate;
    //console.log('flattenCharacteristics: characteristicsId=', characteristicsId, ' stateToUpdate=', stateToUpdate);
    var characteristics = await window.db.clientCharacteristics.findOne({selector:{id: characteristicsId}}).exec();
    if(characteristics === null) return stateToUpdate;
    var characteristicsJSON = characteristics.toJSON();
    var newState = stateToUpdate ?? {};

    newState.characteristicsId = characteristicsJSON.id; // client characteristics id
    newState.bodySites = characteristicsJSON.bodySites; // possible body sites selected from check boxes that may be used for access
    newState.bodySiteComments = characteristicsJSON.bodySiteComments; // comments from selecting body sites
    newState.strengths = characteristicsJSON.languageCognition ? characteristicsJSON.languageCognition[0] : ''; // positive things worth noting about language and cognition
    newState.limitations = characteristicsJSON.languageCognition ? characteristicsJSON.languageCognition[1] : ''; // negative things worth noting about language and cognition
    newState.otherIssues = characteristicsJSON.other; // client characteristic notes besides bodySites, language/cognition, and vision
    newState = this.flattenVisionCharacteristics(characteristicsJSON.visionId, stateToUpdate);
    if(stateToUpdate)
      return newState;
    else{
      this.setState({...newState}, () => {
        //CSFPS sets isLoading true. Here is where we're done loading.
      //(Don't worry about guaranteed completion of the above setState. These don't depend on each other.)
      this.setState({isLoading: false}, () =>{
        console.log('load data complete');
      });
      });
    }
  }

  async flattenVisionCharacteristics(visionId, stateToUpdate){
    if(!visionId || !window.db) return stateToUpdate;
    //console.log('flattenVisionCharacteristics: visionId=', visionId, ' stateToUpdate=', stateToUpdate);
    var visionCharacteristics = await window.db.visionClientCharacteristics.findOne({selector: {id: visionId}}).exec();
    if(visionCharacteristics === null) return stateToUpdate;
    var visionCharacteristicsJSON = visionCharacteristics.toJSON();
    var newState = stateToUpdate ?? {};

    newState.visionId = visionCharacteristicsJSON.id; // client vision characteristics id
    newState.wearsGlasses = visionCharacteristicsJSON.wearsGlasses;
    newState.betterWithGlasses = visionCharacteristicsJSON.betterWithGlasses;
    newState.hasOtherVisualAids = visionCharacteristicsJSON.hasOtherVisualAids;
    newState.visualAidsNotes = visionCharacteristicsJSON.visualAidsNotes;
    newState.formalEvalNotes = visionCharacteristicsJSON.formalEvalNotes;
    newState.visionIssues = visionCharacteristicsJSON.visionIssues;
    newState.issuesNotes = visionCharacteristicsJSON.issuesNotes;
    if(stateToUpdate)
      return newState;
    else{
      this.setState({...newState}, () => {
        //CSFPS sets isLoading true. Here is where we're done loading.
      //(Don't worry about guaranteed completion of the above setState. These don't depend on each other.)
      this.setState({isLoading: false}, () =>{
        console.log('load data complete');
      });
      });
    }
  }

  async flattenTrialTask(trialTaskId, stateToUpdate, allTrialTasks){
    if(!trialTaskId || !window.db) return stateToUpdate;
    console.log('flattenTrialTask: trialTaskId=', trialTaskId, ' stateToUpdate=', stateToUpdate);
    var activeTask = null;
    if(allTrialTasks) 
      activeTask = allTrialTasks.filter(t => t.id === trialTaskId)[0]
    else {
      var activeTaskDoc = await window.db.trialTask.findOne({selector:{id: trialTaskId}}).exec();// current activity from current test drive
      activeTask = activeTaskDoc ? activeTaskDoc.toJSON() : activeTaskDoc;
    }
    var newState = stateToUpdate ?? this.state ?? this.getInitialStateObject();
    if(activeTask){
      newState.activeTestDrive.activeTestDriveCurrentActivity = activeTask.type;
      newState.activeTestDrive.activeTestDriveCurrentActivityName = activeTask.name;
      newState.activeTestDrive.activeTestDriveCurrentActivityNotes = activeTask.notes;
      newState.activeTestDrive.activeTestDriveCurrentActivityDuration = activeTask.duration;
      newState.activeTestDrive.activeTestDriveCurrentActivityRawWPM = activeTask.rawWordsPerMinute;
      newState.activeTestDrive.activeTestDriveCurrentActivityWPM = activeTask.wordsPerMinute;
      newState.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute = activeTask.targetsPerMinute;
      newState.activeTestDrive.activeTestDriveCurrentActivityAccuracy = activeTask.accuracy;
      newState.activeTestDrive.activeTestDriveCurrentActivityExtraActivations = activeTask.extraActivations;
      newState.activeTestDrive.activeTestDriveCurrentActivityDifficulty = activeTask.difficulty;
      newState.activeTestDrive.activeTestDriveCurrentActivityNumTexts = activeTask.numTexts;
      newState.activeTestDrive.activeTestDriveCurrentActivityLanguage = activeTask.language;
      newState.activeTestDrive.activeTestDriveCurrentActivityTextUnit = activeTask.textUnit;
      newState.activeTestDrive.activeTestDriveCurrentActivityNumTargets = activeTask.numTargets;
      newState.activeTestDrive.activeTestDriveCurrentActivityTargetSize = activeTask.targetSize;
      newState.activeTestDrive.activeTestDriveCurrentActivityTargetType = activeTask.targetType;
      newState.activeTestDrive.activeTestDriveCurrentActivityNumPrompts = activeTask.numPrompts;
      newState.activeTestDrive.activeTestDriveCurrentActivityPromptType = activeTask.promptType;
      newState.activeTestDrive.activeTestDriveCurrentActivityComplete = activeTask.completed;
      newState.activeTestDrive.activeTestDriveCurrentActivityComponentStats = activeTask.trialTaskComponentIds;

      var allTaskComponents = await window.db.trialTaskComponent.find({
        selector:{trialTaskId: trialTaskId},
        sort:[{index: 'asc'}]
      }).exec();
      if(allTaskComponents){
        var allTaskComponentsJSON = allTaskComponents.map(x => x.toJSON());
        newState.activeTestDrive.activeTestDriveCurrentActivityComponentStats = allTaskComponentsJSON;
      }

      if(this.state.activeTestDriveId && activeTask.completed){
        var completedTaskIds = newState.activeTestDrive.activeTestDriveActivities.map(t => t.id);
        if(!completedTaskIds.includes(trialTaskId)){
          newState.activeTestDrive.activeTestDriveActivities.push(this.fillActivityObject(activeTask, allTaskComponentsJSON));
        }
      }
    }

    console.log("returning from flattenTT: " + JSON.stringify(newState));
    if(stateToUpdate)
      return newState;
    else{
      this.setState({...newState}, () => {
        //CSFPS sets isLoading true. Here is where we're done loading.
      //(Don't worry about guaranteed completion of the above setState. These don't depend on each other.)
      this.setState({isLoading: false}, () =>{
        console.log('load data complete');
      });
      });
    }
  }

  //Fill a test-drive object with data from a trial, relevant JSON, and trial activities 
  //the params must be prepared by the caller.
  //this function is just to help reduce repetition in flattenDbSession when 
  //creating completedTestDrives, prospects, and picks
  fillTestDriveObject(td, deviceJSON, clientReviewJSON, providerReviewJSON, testDriveActivities){
    let testDrive = {
      trialId: td.id,
      setupName: deviceJSON ? deviceJSON.alias : '',
      accessMethodID: deviceJSON ? deviceJSON.id : '',
      accessMethodName: deviceJSON ? deviceJSON.name : '',
      accessMethodCategory: deviceJSON ? deviceJSON.accessMethodCategory : '',
      accessMethodSelectionMethods: deviceJSON ? deviceJSON.accessMethodSelectionMethods : [],
      setupSelectionMethod: deviceJSON ? deviceJSON.selectionMethod : '',
      setupBodySite: deviceJSON ? deviceJSON.bodySite : '', 
      setupBodySiteComments: deviceJSON ? deviceJSON.bodySiteComments : '',
      setupAccessories: deviceJSON ? deviceJSON.accessories : '',
      setupPositioningNotes: deviceJSON ? deviceJSON.positioningNotes : '',
      setupOtherNotes: deviceJSON ? deviceJSON.notes : '',
      activities: testDriveActivities,
      clientRating: clientReviewJSON ? clientReviewJSON.rating : '',
      clientFeedback: clientReviewJSON ? clientReviewJSON.feedback : '',
      practitionerRating: providerReviewJSON ? providerReviewJSON.rating: '',
      practitionerComments: providerReviewJSON ? providerReviewJSON.feedback : '',
      issuesNoted: td.issues,
      priorityActivity: td.priorityActivity,
      needsMet: td.needsMet,
      comments: td.comments,
      nextSteps: td.nextSteps,
    }
    return testDrive;
  }
  //Reset App.state to a starting state
  //TODO reconcile this against everything in App's constructor.
  //there are a few items that are not in getInitialStateObject(), like activeTestDriveId, client.id, provider.id, sessionID. 
  //Per Erik, we do not want to reset those id's in getInitialStateObject().
  //There are also a couple items in getInitialStateObject() are not in App.state as constructed, like activeTestDriveCurrentActivityComponentStats
  getInitialStateObject(){
    const initialState = {
      client: null,
      //removed this as part of allowing a logged-in provider to do an eval without saving client data:
      //https://www.pivotaltracker.com/story/show/188678629
      // provider: null,
      mainGoal: "",
      activities: [],
      priority: "",
      platforms: [],
      environments: [],
      bodyPositions: [],
      indepSetup: "",
      indepUse: "",
      hasCurrentMethod: "",
      currentMethods: [],
      pastMethods: [],
      platformsUsed: [],
      bodySites: [],
      bodySiteComments: "",
      wearsGlasses: "",
      betterWithGlasses: "",
      hasOtherVisualAids: "",
      visualAidsNotes: "",
      formalEvalNotes: "",
      visionIssues: [],
      issuesNotes: "",
      strengths: "",
      limitations: "",
      otherIssues: "",
      //TD object experiment with activeTestDrive object. 
      activeTestDrive: {
        //.trialId will be added elsewhere when the activeTestDrive is created
        activeAccessMethodID: "",
        activeAccessMethodName: "",
        activeAccessMethodCategory: "",
        activeAccessMethodSelectionMethods: [],
        activeSetupSelectionMethod: "",
        activeSetupBodySite: [],
        activeSetupBodySiteComments: "",
        activeSetupAccessories: [],
        activeSetupPositioningNotes: "",
        activeSetupOtherNotes: "",
        activeSetupName: "", 
        activeTestDriveClientRating: "",
        activeTestDriveClientFeedback: "",
        activeTestDrivePractitionerRating: "",
        activeTestDriveIssuesNoted: [],
        activeTestDrivePractitionerComments: "",
        activeTestDriveActivities: [],
        //state needed for the test-drive/try section: (start out empty so testDrive.hasAnyValues returns false)
        activeTestDriveCurrentActivity: "",
        activeTestDriveCurrentActivityName: "",
        //these default settings MUST be undefined, to allow the test to fill in default values.
        // if they are empty strings, the text field for entering them will be empty, rather than default value.
        // and if they are actual default values, the testDriveHasAnyValues() method will not be correct.
        activeTestDriveCurrentActivityNumTexts: undefined, //'', //('' + DEFAULT_TEXTS_IN_TEST),
        activeTestDriveCurrentActivityLanguage: undefined, //'', //DEFAULT_TEXT_LANGUAGE,
        activeTestDriveCurrentActivityTextUnit: undefined, //'', //DEFAULT_TEXT_UNIT,
        activeTestDriveCurrentActivityNumTargets: undefined, //'', //('' + DEFAULT_TARGETS_IN_TEST),
        activeTestDriveCurrentActivityTargetSize: undefined, //'', //('' + DEFAULT_TARGET_SIZE),
        activeTestDriveCurrentActivityTargetType: undefined, //'', //DEFAULT_TARGET_TYPE,
        activeTestDriveCurrentActivityNumPrompts: undefined, //'', //('' + DEFAULT_HITS_IN_TEST),
        activeTestDriveCurrentActivityPromptType: undefined, //'', //DEFAULT_TARGET_TYPE,
        activeTestDriveCurrentActivityNotes: "",
        activeTestDriveCurrentActivityComponentStats:[],
        activeTestDriveCurrentActivityDuration: "",
        activeTestDriveCurrentActivityRawWPM: "",
        activeTestDriveCurrentActivityWPM: "",
        activeTestDriveCurrentActivityTargetsPerMinute: "",
        activeTestDriveCurrentActivityAccuracy: "",
        activeTestDriveCurrentActivityExtraActivations: "",
        activeTestDriveCurrentActivityDifficulty: "",
      },
      
      //state needed for the test-drive/choose section:
      firstMethodCategory: "",


      completedTestDrives: [],
      prospects: [],
      picks: [],
      summaryNotes: "",
      backgroundNotes: "",
      abilitiesNotes: "",
      testdrivesNotes: "",
      decisionsNotes: "",
      recommendationsNotes: ""
    }

    return(initialState);
  }

  //TODO unclear if this stores changes to clientName or providerName in the database.
  //or what we want to do when the only change is to providerName, say.
  //Added a patch to put the state names into the session.
  async updateDatabaseFromState(){
    var runningRemoteTestDrive = window.testDriveClinicianId && window.testDriveTaskId;
    console.log('*** UDFS ENTERED enter updateDatabaseFromState, id=' + this.state.sessionID + ' alreadyUpdating=' + window.updatingDatabase + ' callsWhileUpdating=' + window.callsWhileUpdating + ' runningRemoteTestDrive=' + runningRemoteTestDrive);
    if(!this.state.clientId && !runningRemoteTestDrive){
      console.log("  * UDFS No clientId so nowhere to save data");
      return;
    }
    if(window.updatingDatabase){
      console.log("  * UDFS OOPS: updateDatabaseFromState still not done from last time.");
      //console.log("  * turn off the flag so it has a chance next time.");
      //window.updatingDatabase=false;
      window.callsWhileUpdating += 1;
      console.log("  * UDFS keep track of how many times it is called: " + window.callsWhileUpdating);
      return;
    }
    window.updatingDatabase = true;
    window.callsWhileUpdating = 0;

    try{
      const session = await window.db.session.findOne({selector:{id: this.state.sessionID}}).exec();

      var allRelatedClinicianIds = await this.getAllProviders(this.state.client);

      if(session && !runningRemoteTestDrive){
        console.log('  * UDFS updateDatabaseFromState, client=' + this.state.clientId + ' sessionToUpdate=', session.toJSON());
        await session.incrementalPatch({
          platforms: this.state.platforms,
          locations: this.state.environments,
          positions: this.state.bodyPositions,
          independentSetup: this.state.indepSetup,
          independentUse: this.state.indepUse,
          firstMethodCategory: this.state.firstMethodCategory,
          platformsUsed: this.state.platformsUsed,
          summaryNotes: this.state.summaryNotes,
          backgroundNotes: this.state.backgroundNotes,
          abilitiesNotes: this.state.abilitiesNotes,
          testdrivesNotes: this.state.testdrivesNotes,
          decisionsNotes: this.state.decisionsNotes,
          recommendationsNotes: this.state.recommendationsNotes,
          onlyAvailableLocally: this.state.client.onlyAvailableLocally,
          updatedAt: new Date().getTime(),
          end: new Date().getTime(),
          clinicianIds: allRelatedClinicianIds
        });

        // update clientGoals
        var goals = await window.db.clientGoal.find({selector:{id: {$in: session.toJSON().goalIds}}}).exec();
        var goalsJSON = goals.map(x => x.toJSON());
        if(goals && goals.length > 0){
          // var deletedGoals = Enumerable.from(goals).select(g => g.task).where(goal => !Enumerable.from(this.state.activities).contains(goal)).toArray();
          var deletedGoals = Enumerable.from(goalsJSON).where(goal => !Enumerable.from(this.state.activities).contains(goal.task)).toArray();
          var goalIDs = goalsJSON.map(g => g.id);
          for(const deletedGoal of deletedGoals){
            var index = goalIDs.indexOf(deletedGoal.id);
            if(index >= 0 && index < goals.length){
              goals[index].remove();
              goals.splice(index, 1);
            }
          }
        }

        var missingGoals = Enumerable.from(this.state.activities).where(activity => !Enumerable.from(goalsJSON).select(goal => goal.task).contains(activity)).toArray();
        for(const missingGoal of missingGoals){
          let newGoal = {
            id:uuid(),
            priority: missingGoal === this.state.priority ? 1 : 0,
            type: 0,
            task: missingGoal,
            onlyAvailableLocally: this.state.client.onlyAvailableLocally,
            updatedAt: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          }
          goals.push(await window.db.clientGoal.insert(newGoal));
        };

        if(goals){
          for(const goal of goals){
            var goalJSON = goal.toJSON();
            await goal.incrementalPatch({
              priority: goalJSON.task === this.state.priority ? 1 : 0,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
          }
        }

        var goalIds = Enumerable.from(goals).select(g => g.id).toArray();
        await session.incrementalPatch({
          goalIds: goalIds,
          updatedAt: new Date().getTime(),
          end: new Date().getTime()
        });

        // update clientCharacteristics
        var characteristics = await window.db.clientCharacteristics.findOne({selector:{id: session.toJSON().characteristicsId}}).exec();
        var characteristicsJSON = characteristics ? characteristics.toJSON() : characteristics;
        // console.log("updateDatabaseFromState, session.characteristics: " + session.toJSON().characteristicsId + " retrieved characteristics: " + characteristicsJSON);
        if(session.toJSON().characteristicsId && characteristics){

          await characteristics.incrementalPatch({
            bodySites: this.state.bodySites,
            bodySiteComments: this.state.bodySiteComments,
            languageCognition: [this.state.strengths, this.state.limitations],
            other: this.state.otherIssues,
            onlyAvailableLocally: this.state.client.onlyAvailableLocally,
            updatedAt: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          });

          // update visionClientCharacteristics
          var visionCharacteristics = await window.db.visionClientCharacteristics.findOne({selector: {id: characteristicsJSON.visionId}}).exec();
          if(visionCharacteristics){
            await visionCharacteristics.incrementalPatch({
              wearsGlasses: this.state.wearsGlasses,
              betterWithGlasses: this.state.betterWithGlasses,
              hasOtherVisualAids: this.state.hasOtherVisualAids,
              visualAidsNotes: this.state.visualAidsNotes,
              formalEvalNotes: this.state.formalEvalNotes,
              visionIssues: this.state.visionIssues,
              issuesNotes: this.state.issuesNotes,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
          }else{
            let newCharacteristics = {
              id:uuid(),
              wearsGlasses: this.state.wearsGlasses,
              betterWithGlasses: this.state.betterWithGlasses,
              hasOtherVisualAids: this.state.hasOtherVisualAids,
              visualAidsNotes: this.state.visualAidsNotes,
              formalEvalNotes: this.state.formalEvalNotes,
              visionIssues: this.state.visionIssues,
              issuesNotes: this.state.issuesNotes,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            };
            await window.db.visionClientCharacteristics.insert(newCharacteristics);
            await characteristics.incrementalPatch({
              visionId: newCharacteristics.id,
              updatedAt: new Date().getTime()
            });
          }
        }else{
          let newVisionCharacteristics = {
            id:uuid(),
            wearsGlasses: this.state.wearsGlasses,
            betterWithGlasses: this.state.betterWithGlasses,
            hasOtherVisualAids: this.state.hasOtherVisualAids,
            visualAidsNotes: this.state.visualAidsNotes,
            formalEvalNotes: this.state.formalEvalNotes,
            visionIssues: this.state.visionIssues,
            issuesNotes: this.state.issuesNotes,
            onlyAvailableLocally: this.state.client.onlyAvailableLocally,
            updatedAt: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          };
          await window.db.visionClientCharacteristics.insert(newVisionCharacteristics);
          let newCharacteristics = {
            id:uuid(),
            bodySites: this.state.bodySites,
            bodySiteComments: this.state.bodySiteComments,
            visionId: newVisionCharacteristics.id,
            languageCognition: [this.state.strengths, this.state.limitations],
            other: this.state.otherIssues,
            onlyAvailableLocally: this.state.client.onlyAvailableLocally,
            updatedAt: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          };
          // console.log("updateDatabaseFromState, new characteristics: " + characteristics);
          await window.db.clientCharacteristics.insert(newCharacteristics);
          await session.incrementalPatch({
            characteristicsId: newCharacteristics.id,
            updatedAt: new Date().getTime(),
            end: new Date().getTime()
          });
        }

        // update active trial
        // console.log('***UDFS updating testDrives updateDatabaseFromState, activeTestDriveId=' + this.state.activeTestDriveId);
        var allHistory = session.toJSON().historyIds;
        if(this.state.activeTestDriveId){
          var trial = await window.db.trial.findOne({selector:{id: this.state.activeTestDriveId}}).exec();
          var trialJson;
          if(trial){
            await trial.incrementalPatch({
              issues: this.state.activeTestDrive.activeTestDriveIssuesNoted,
              priorityActivity: this.state.priority, 
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              end: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
            trialJson = trial.toJSON();
          }else{
            trialJson = {
              id: this.state.activeTestDriveId,
              issues: [],
              deviceId: uuid(),
              isProspect: true,
              isPick: false,
              priorityActivity: this.state.priority, 
              start: new Date().getTime(),
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              end: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            };
            trial = await window.db.trial.insert(trialJson);
            trialJson = trial.toJSON();
          }
          var allTrials = session.toJSON().trialIds ?? [];
          if(!allTrials.includes(this.state.activeTestDriveId)){
            allTrials.push(this.state.activeTestDriveId);
            await session.incrementalPatch({
              trialIds: allTrials,
              updatedAt: new Date().getTime(),
              end: new Date().getTime()
            });
          }

          // console.log('***UDFS updating testDrive tasks updateDatabaseFromState, activeTrialTaskId=[' + this.state.activeTrialTaskId + "], components=", this.state.activeTestDriveCurrentActivityComponentStats);
          // update active task.
          if(this.state.activeTrialTaskId){
            var task = await window.db.trialTask.findOne({selector:{id: this.state.activeTrialTaskId}}).exec();
            var componentIds = [];
            var components = await window.db.trialTaskComponent.find({selector:{trialTaskId: this.state.activeTrialTaskId}}).exec();
            let numComponents = 0;
            if (Array.isArray(this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats)){
              numComponents = this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats.length;
            }
            for(var i = 0; i < numComponents; ++i){
              var toSave = this.state.activeTestDrive.activeTestDriveCurrentActivityComponentStats[i];
              var component = components.filter(c => c.index === i)[0];
              if(component){
                await component.incrementalPatch({
                  trialTaskId: this.state.activeTrialTaskId,
                  index: i,
                  sentence: toSave.sentence ?? '',
                  duration: toSave.duration ?? -1,
                  targetTextLength: toSave.targetTextLength ?? -1,
                  totalWords: toSave.totalWords ?? -1,
                  totalSelections: toSave.totalSelections ?? -1,
                  minStringDistance: toSave.minStringDistance ?? -1,
                  targetEntries: toSave.targetEntries ?? -1,
                  clicks: toSave.clicks ?? -1,
                  activationType: toSave.activationType ?? '',
                  trialTime: toSave.trialTime ?? -1,
                  reactionTime: toSave.reactionTime ?? -1,
                  holdTime: toSave.holdTime ?? -1,
                  hiddenTime: toSave.hiddenTime ?? -1,
                  awaitedRelease: toSave.awaitedRelease ?? false,
                  extraActivations: toSave.extraActivations ?? -1,
                  onlyAvailableLocally: this.state.client.onlyAvailableLocally,
                  updatedAt: new Date().getTime(),
                  clinicianIds: allRelatedClinicianIds
                });
                // console.log('***UDFS updated test drive components updateDatabaseFromState, component=', component.toJSON());
                componentIds.push(component.toJSON().id);
              }else{
                component = {
                  id: uuid(),
                  trialTaskId: this.state.activeTrialTaskId,
                  index: i,
                  sentence: toSave.sentence ?? '',
                  duration: toSave.duration ?? -1,
                  targetTextLength: toSave.targetTextLength ?? -1,
                  totalWords: toSave.totalWords ?? -1,
                  totalSelections: toSave.totalSelections ?? -1,
                  minStringDistance: toSave.minStringDistance ?? -1,
                  targetEntries: toSave.targetEntries ?? -1,
                  clicks: toSave.clicks ?? -1,
                  activationType: toSave.activationType ?? '',
                  trialTime: toSave.trialTime ?? -1,
                  reactionTime: toSave.reactionTime ?? -1,
                  holdTime: toSave.holdTime ?? -1,
                  hiddenTime: toSave.hiddenTime ?? -1,
                  awaitedRelease: toSave.awaitedRelease ?? false,
                  extraActivations: toSave.extraActivations ?? -1,
                  onlyAvailableLocally: this.state.client.onlyAvailableLocally,
                  updatedAt: new Date().getTime(),
                  clinicianIds: allRelatedClinicianIds
                }
                await window.db.trialTaskComponent.insert(component);
                // console.log('***UDFS inserted test drive components updateDatabaseFromState, component=', component);
                componentIds.push(component.id);
              }
            }
            // console.log('***UDFS saved test drive components updateDatabaseFromState, componentIds=', componentIds);
            if(task){
              await task.incrementalPatch({
                type: this.state.activeTestDrive.activeTestDriveCurrentActivity ?? '',
                name: this.state.activeTestDrive.activeTestDriveCurrentActivityName ?? '',
                numTexts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts ?? '',
                language: this.state.activeTestDrive.activeTestDriveCurrentActivityLanguage ?? '',
                textUnit: this.state.activeTestDrive.activeTestDriveCurrentActivityTextUnit ?? '',
                numTargets: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTargets ?? '',
                targetSize: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetSize ?? '',
                targetType: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetType ?? '',
                numPrompts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumPrompts ??'',
                promptType: this.state.activeTestDrive.activeTestDriveCurrentActivityPromptType ?? '',
                taskNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes ?? '',
                duration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration ?? '',
                rawWordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM ?? '',
                wordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityWPM ?? '',
                targetsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute ?? '',
                accuracy: this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy ?? '',
                extraActivations: this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations ?? '',
                difficulty: this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty ?? '',
                completed: this.state.activeTestDrive.activeTestDriveCurrentActivityComplete ?? false,
                trialTaskComponentIds: componentIds ?? [],
                onlyAvailableLocally: this.state.client.onlyAvailableLocally,
                updatedAt: new Date().getTime(),
                end: new Date().getTime(),
                clinicianIds: allRelatedClinicianIds
              });
            }else{
              task = {
                id: this.state.activeTrialTaskId,
                start: new Date().getTime(),
                name: this.state.activeTestDrive.activeTestDriveCurrentActivityName ?? '',
                numTexts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts ?? '',
                language: this.state.activeTestDrive.activeTestDriveCurrentActivityLanguage ?? '',
                textUnit: this.state.activeTestDrive.activeTestDriveCurrentActivityTextUnit ?? '',
                numTargets: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTargets ?? '',
                targetSize: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetSize ?? '',
                targetType: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetType ?? '',
                numPrompts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumPrompts ??'',
                promptType: this.state.activeTestDrive.activeTestDriveCurrentActivityPromptType ?? '',
                description:'',
                type: this.state.activeTestDrive.activeTestDriveCurrentActivity ?? '',
                taskNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes ?? '',
                duration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration ?? '',
                rawWordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM ?? '',
                wordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityWPM ?? '',
                targetsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute ?? '',
                accuracy: this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy ?? '',
                extraActivations: this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations ?? '',
                difficulty: this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty ?? '',
                completed: this.state.activeTestDrive.activeTestDriveCurrentActivityComplete ?? false,
                trialTaskComponentIds: componentIds ?? [],
                onlyAvailableLocally: this.state.client.onlyAvailableLocally,
                updatedAt: new Date().getTime(),
                end: new Date().getTime(),
                clinicianIds: allRelatedClinicianIds
              };
              await window.db.trialTask.insert(task);
            }
            var allTasks = trialJson.trialTaskIds ?? [];
            if(allTasks.findIndex(x => x === task.id) === -1)
            {
              allTasks.push(task.id);
              await trial.incrementalPatch({
                trialTaskIds: allTasks,
                updatedAt: new Date().getTime(),
                end: new Date().getTime()
              });
            }
          }

          // update if task is completed
          if(allTasks){
            var tasks = await window.db.trialTask.find({
              selector:{id: {$in: allTasks}},
              sort: [{end: 'asc'}]
            }).exec();
            for(const t of tasks){
              var taskJson = t.toJSON();
              var completed  = Array.isArray(this.state.activeTestDrive.activeTestDriveActivities) ? this.state.activeTestDrive.activeTestDriveActivities.some(m => m && m.id === taskJson.id) : false;
              await t.incrementalPatch({
                completed: completed,
                updatedAt: new Date().getTime(),
                end: new Date().getTime()
              });
            }
          }
          
          // update client reviews
          var clientReview = await window.db.trialReview.findOne({selector : {$and:[{trialId: trialJson.id},{reviewerId: session.toJSON().clientId}]}}).exec();
          var allReviews = trialJson.reviewIds ?? [];
          if(clientReview){
            await clientReview.incrementalPatch({
              rating: this.state.activeTestDrive.activeTestDriveClientRating,
              feedback: this.state.activeTestDrive.activeTestDriveClientFeedback,
              time: new Date().getTime(),
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
          }else{
            clientReview = {
              id: uuid(),
              reviewerId: session.toJSON().clientId,
              time: new Date().getTime(),
              trialId: trialJson.id,
              rating: this.state.activeTestDrive.activeTestDriveClientRating,
              feedback: this.state.activeTestDrive.activeTestDriveClientFeedback,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            };
            await window.db.trialReview.insert(clientReview);
            allReviews.push(clientReview.id);
            await trial.incrementalPatch({
              reviewIds: allReviews,
              updatedAt: new Date().getTime(),
              end: new Date().getTime()
            });
          }

          // update practitioner reviews
          var practitionerReview = await window.db.trialReview.findOne({selector : {$and:[{trialId: trialJson.id},{reviewerId: session.toJSON().clinicianId}]}}).exec();
          if(practitionerReview){
            await practitionerReview.incrementalPatch({
              rating: this.state.activeTestDrive.activeTestDrivePractitionerRating,
              feedback: this.state.activeTestDrive.activeTestDrivePractitionerComments,
              time: new Date().getTime(),
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
          }else{
            practitionerReview = {
              id: uuid(),
              reviewerId: session.toJSON().clinicianId,
              time: new Date().getTime(),
              trialId: trialJson.id,
              rating: this.state.activeTestDrive.activeTestDrivePractitionerRating,
              feedback: this.state.activeTestDrive.activeTestDrivePractitionerComments,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            };
            await window.db.trialReview.insert(practitionerReview);
            allReviews.push(practitionerReview.id);
            await trial.incrementalPatch({
              reviewIds: allReviews,
              updatedAt: new Date().getTime(),
              end: new Date().getTime()
            });
          }


          // update active access method
          var activeAccessMethod = await window.db.clientAccessMethod.findOne({selector: {id : trialJson.deviceId}}).exec();
          // var accessMethodFromLibrary = await window.db.accessMethod.findOne({selector: {name: this.state.activeAccessMethodName}}).exec();
          var accessMethodJSON;
          if(activeAccessMethod){
            await activeAccessMethod.incrementalPatch({
              //it already has an id, so no need to patch that
              accessMethodReadableId: this.state.activeTestDrive.activeAccessMethodID,
              name: this.state.activeTestDrive.activeAccessMethodName,
              accessMethodCategory: this.state.activeTestDrive.activeAccessMethodCategory,
              possibleSelectionMethods: this.state.activeTestDrive.activeAccessMethodSelectionMethods,
              selectionMethod: this.state.activeTestDrive.activeSetupSelectionMethod,

              alias: this.state.activeTestDrive.activeSetupName,
              bodySite: this.state.activeTestDrive.activeSetupBodySite,
              bodySiteComments: this.state.activeTestDrive.activeSetupBodySiteComments,
              positioningNotes: this.state.activeTestDrive.activeSetupPositioningNotes,
              notes: this.state.activeTestDrive.activeSetupOtherNotes,
              accessories: this.state.activeTestDrive.activeSetupAccessories,

              //accessMethodId is a holdover from when we had a database for the profiles. No longer used.
              accessMethodId: '', //accessMethodFromLibrary ? accessMethodFromLibrary.toJSON().id : accessMethodFromLibrary,
              productName: '',
              currentlyUsed: Array.isArray(this.state.currentMethods) && this.state.currentMethods.some(m => m && m.name === this.state.activeSetupName),
              previouslyUsed: Array.isArray(this.state.pastMethods) && this.state.pastMethods.some(m => m && m.name === this.state.activeSetupName),
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
            accessMethodJSON = activeAccessMethod.toJSON();
          }else{
            activeAccessMethod = {
              id: trialJson.deviceId,
              accessMethodReadableId: this.state.activeTestDrive.activeAccessMethodID,
              name: this.state.activeTestDrive.activeAccessMethodName,
              accessMethodCategory: this.state.activeTestDrive.activeAccessMethodCategory,
              possibleSelectionMethods: this.state.activeTestDrive.activeAccessMethodSelectionMethods,
              selectionMethod: this.state.activeTestDrive.activeSetupSelectionMethod,

              alias: this.state.activeTestDrive.activeSetupName,
              bodySite: this.state.activeTestDrive.activeSetupBodySite,
              bodySiteComments: this.state.activeTestDrive.activeSetupBodySiteComments,
              positioningNotes: this.state.activeTestDrive.activeSetupPositioningNotes,
              notes: this.state.activeTestDrive.activeSetupOtherNotes,
              accessories: this.state.activeTestDrive.activeSetupAccessories,

              currentlyUsed: Array.isArray(this.state.currentMethods) && this.state.currentMethods.some(m => m && m.name === this.state.activeSetupName),
              previouslyUsed: Array.isArray(this.state.pastMethods) && this.state.pastMethods.some(m => m && m.name === this.state.activeSetupName),
              productName: '',
              //these are holdovers from when we had a database for the profiles. No longer used.
              accessMethodId: '', // accessMethodFromLibrary ? accessMethodFromLibrary.toJSON().id : accessMethodFromLibrary,
              satisfaction: -1,
              independentSetup: '',
              independentUse: '',

              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            };
            var inserted = await window.db.clientAccessMethod.insert(activeAccessMethod);
            accessMethodJSON = inserted.toJSON();
            // console.log("saveSession, methodAdded=", accessMethodJSON);
          }
          if(allHistory.findIndex(x => x === accessMethodJSON.id) === -1)
            {
              allHistory.push(accessMethodJSON.id);
              await session.incrementalPatch({
                historyIds: allHistory,
                updatedAt: new Date().getTime(),
                end: new Date().getTime()
              });
            }
        }

        console.log("*** UDFS: About to update prospects");

        // update picks/prospects
        if(session.toJSON().trialIds){
          var trials = await window.db.trial.find({selector:{id: { $in : session.toJSON().trialIds}}}).exec();
          console.log("checking trials", trials);
          console.log("checking prospects:",this.state.prospects);
          // console.log("checking picks", this.state.picks);
          for(const trial of trials){
            trialJson = trial.toJSON();
            var prospects = Array.isArray(this.state.prospects) ? this.state.prospects.filter(m => m && m.trialId === trialJson.id) : [];
            var isProspect = Array.isArray(prospects) && prospects.length > 0;
            var picks = Array.isArray(this.state.picks) ? this.state.picks.filter(m => m && m.trialId === trialJson.id) : [];
            var isPick = Array.isArray(picks) && picks.length > 0;
            var needsMet = isPick ? picks[0].needsMet : (isProspect ? prospects[0].needsMet : []);
            var comments = isPick ? picks[0].comments : (isProspect ? prospects[0].comments : '');
            var nextSteps = isPick ? picks[0].nextSteps : (isProspect ? prospects[0].nextSteps : '');
            await trial.incrementalPatch({
              isProspect: isProspect,
              isPick: isPick,
              needsMet: needsMet,
              comments: comments,
              nextSteps: nextSteps,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              // end: new Date().getTime() -- This is commented out because the trial has ended so we shouldn't be updating the end value
            });
          }
        }

        // update access method history
        //TODO using name as retrieval key seems problematic.
        //Current methods name is freetext. Test drive method name is direct from profile (so will be repeated)
        if(session.toJSON().historyIds){
          var accessMethods = await window.db.clientAccessMethod.find({selector:{id: { $in : session.toJSON().historyIds}}}).exec();
          for(const method of accessMethods){
            var methodJSON = method.toJSON();
            var curMethod = Array.isArray(this.state.currentMethods) && this.state.currentMethods.some(m => m && m.name && m.name === methodJSON.name);
            var prevMethod = Array.isArray(this.state.pastMethods) && this.state.pastMethods.some(m => m && m.name && m.name === methodJSON.name);
            await method.incrementalPatch({
              currentlyUsed: curMethod,
              previouslyUsed: prevMethod,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            });
          }
        }

        var accessMethodsJSON = accessMethods.map(a => a.toJSON());
        var missingMethods = Enumerable.from(this.state.currentMethods).where(toFind => !Enumerable.from(accessMethodsJSON).select(cam => cam.name).contains(toFind.name)).toArray();
        missingMethods = missingMethods.concat(Enumerable.from(this.state.pastMethods).where(toFind => !Enumerable.from(accessMethodsJSON).select(cam => cam.name).contains(toFind.name) && !Enumerable.from(missingMethods).select(cam => cam.name).contains(toFind.name)).toArray());
        for(const missingMethod of missingMethods){
          if(missingMethod.name){
            let newMethod = {
              id:uuid(),
              name: missingMethod.name,
              alias: missingMethod.alias,
              currentlyUsed: Array.isArray(this.state.currentMethods) && this.state.currentMethods.some(m => m && m.name && m.name === missingMethod.name),
              previouslyUsed: Array.isArray(this.state.pastMethods) && this.state.pastMethods.some(m => m && m.name && m.name === missingMethod.name),
              accessMethodId: missingMethod.accessMethodId,
              productName: missingMethod.productName,
              bodySite: missingMethod.bodySite,
              bodySiteComments: missingMethod.bodySiteComments,
              satisfaction: missingMethod.satisfaction,
              independentSetup: missingMethod.independentSetup,
              independentUse: missingMethod.independentUse,
              positioningNotes:missingMethod.positioningNotes,
              notes:missingMethod.notes,
              accessMethodReadableId: missingMethod.accessMethodReadableId,
              accessMethodCategory: missingMethod.accessMethodCategory,
              selectionMethod: missingMethod.selectionMethod,
              possibleSelectionMethods: missingMethod.possibleSelectionMethods,
              accessories: missingMethod.accessories,
              onlyAvailableLocally: this.state.client.onlyAvailableLocally,
              updatedAt: new Date().getTime(),
              clinicianIds: allRelatedClinicianIds
            };
            // console.log('exit saveSession, addedMethod=', newMethod);
            var inserted = await window.db.clientAccessMethod.insert(newMethod);
            // console.log("saveSession, methodAdded=", inserted.toJSON());
            if(allHistory.findIndex(x => x === newMethod.id) === -1)
              {
                allHistory.push(newMethod.id);
              }
          }
        }
        await session.incrementalPatch({
          historyIds: allHistory,
          updatedAt: new Date().getTime(),
          end: new Date().getTime()
        });

        var sessionJSON = session.toJSON();
        if(sessionJSON.clientId){
          var client = await window.db.person.findOne({selector:{id:sessionJSON.clientId}}).exec();
          if(client){
            await client.incrementalPatch({
              updatedAt: new Date().getTime()
            });
          }
        }
    
        if(sessionJSON.clinicianId){
          var clinician = await window.db.person.findOne({selector: {id:sessionJSON.clinicianId}}).exec();
          if(clinician){
            await clinician.incrementalPatch({
              updatedAt: new Date().getTime()
            });
          }
        }
      }else if(runningRemoteTestDrive){
        var task = await window.db.trialTask.findOne({selector:{id: window.testDriveTaskId}}).exec();
        if(task){
          var completedTask = this.state.activeTestDrive.activeTestDriveActivities.filter(m => m && m.id === window.testDriveTaskId)[0];
          allRelatedClinicianIds = task.toJSON().clinicianIds;
          var componentIds = [];
          var components = await window.db.trialTaskComponent.find({
            selector:{trialTaskId: window.testDriveTaskId},
            sort:[{index: 'asc'}]
          }).exec();
          for(var i = 0; i < completedTask.components.length; ++i){
            var toSave = completedTask.components[i];
            var component = components.filter(c => c.index === i)[0];
            if(component){
              await component.incrementalPatch({
                trialTaskId: window.testDriveTaskId,
                index: i,
                sentence: toSave.sentence ?? '',
                duration: toSave.duration ?? -1,
                targetTextLength: toSave.targetTextLength ?? -1,
                totalWords: toSave.totalWords ?? -1,
                totalSelections: toSave.totalSelections ?? -1,
                minStringDistance: toSave.minStringDistance ?? -1,
                targetEntries: toSave.targetEntries ?? -1,
                clicks: toSave.clicks ?? -1,
                activationType: toSave.activationType ?? '',
                trialTime: toSave.trialTime ?? -1,
                reactionTime: toSave.reactionTime ?? -1,
                holdTime: toSave.holdTime ?? -1,
                hiddenTime: toSave.hiddenTime ?? -1,
                awaitedRelease: toSave.awaitedRelease ?? false,
                extraActivations: toSave.extraActivations ?? -1,
                onlyAvailableLocally: false,
                updatedAt: new Date().getTime(),
                clinicianIds: allRelatedClinicianIds
              });
              // console.log('***UDFS updated test drive components updateDatabaseFromState, component=', component.toJSON());
              componentIds.push(component.toJSON().id);
            }else{
              component = {
                id: uuid(),
                trialTaskId: window.testDriveTaskId,
                index: i,
                sentence: toSave.sentence ?? '',
                duration: toSave.duration ?? -1,
                targetTextLength: toSave.targetTextLength ?? -1,
                totalWords: toSave.totalWords ?? -1,
                totalSelections: toSave.totalSelections ?? -1,
                minStringDistance: toSave.minStringDistance ?? -1,
                targetEntries: toSave.targetEntries ?? -1,
                clicks: toSave.clicks ?? -1,
                activationType: toSave.activationType ?? '',
                trialTime: toSave.trialTime ?? -1,
                reactionTime: toSave.reactionTime ?? -1,
                holdTime: toSave.holdTime ?? -1,
                hiddenTime: toSave.hiddenTime ?? -1,
                awaitedRelease: toSave.awaitedRelease ?? false,
                extraActivations: toSave.extraActivations ?? -1,
                onlyAvailableLocally: false,
                updatedAt: new Date().getTime(),
                clinicianIds: allRelatedClinicianIds
              }
              await window.db.trialTaskComponent.insert(component);
              // console.log('***UDFS inserted test drive components updateDatabaseFromState, component=', component);
              componentIds.push(component.id);
            }
          }
          // console.log('***UDFS saved test drive components updateDatabaseFromState, componentIds=', componentIds);
          await task.incrementalPatch({
            type: this.state.activeTestDrive.activeTestDriveCurrentActivity ?? '',
            name: this.state.activeTestDrive.activeTestDriveCurrentActivityName ?? '',
            numTexts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts ?? '',
            language: this.state.activeTestDrive.activeTestDriveCurrentActivityLanguage ?? '',
            textUnit: this.state.activeTestDrive.activeTestDriveCurrentActivityTextUnit ?? '',
            numTargets: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTargets ?? '',
            targetSize: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetSize ?? '',
            targetType: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetType ?? '',
            numPrompts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumPrompts ??'',
            promptType: this.state.activeTestDrive.activeTestDriveCurrentActivityPromptType ?? '',
            taskNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes ?? '',
            duration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration ?? '',
            rawWordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM ?? '',
            wordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityWPM ?? '',
            targetsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute ?? '',
            accuracy: this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy ?? '',
            extraActivations: this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations ?? '',
            difficulty: this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty ?? '',
            trialTaskComponentIds: componentIds ?? [],
            completed: !!this.state.returnToOtherComputer,
            updatedAt: new Date().getTime(),
            end: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          });
        }else{
          task = {
            id: window.testDriveTaskId,
            start: new Date().getTime(),
            name: this.state.activeTestDrive.activeTestDriveCurrentActivityName ?? '',
            numTexts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTexts ?? '',
            language: this.state.activeTestDrive.activeTestDriveCurrentActivityLanguage ?? '',
            textUnit: this.state.activeTestDrive.activeTestDriveCurrentActivityTextUnit ?? '',
            numTargets: this.state.activeTestDrive.activeTestDriveCurrentActivityNumTargets ?? '',
            targetSize: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetSize ?? '',
            targetType: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetType ?? '',
            numPrompts: this.state.activeTestDrive.activeTestDriveCurrentActivityNumPrompts ??'',
            promptType: this.state.activeTestDrive.activeTestDriveCurrentActivityPromptType ?? '',
            description:'',
            type: this.state.activeTestDrive.activeTestDriveCurrentActivity ?? '',
            taskNotes: this.state.activeTestDrive.activeTestDriveCurrentActivityNotes ?? '',
            duration: this.state.activeTestDrive.activeTestDriveCurrentActivityDuration ?? '',
            rawWordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityRawWPM ?? '',
            wordsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityWPM ?? '',
            targetsPerMinute: this.state.activeTestDrive.activeTestDriveCurrentActivityTargetsPerMinute ?? '',
            accuracy: this.state.activeTestDrive.activeTestDriveCurrentActivityAccuracy ?? '',
            extraActivations: this.state.activeTestDrive.activeTestDriveCurrentActivityExtraActivations ?? '',
            difficulty: this.state.activeTestDrive.activeTestDriveCurrentActivityDifficulty ?? '',
            trialTaskComponentIds: componentIds ?? [],
            onlyAvailableLocally: false,
            updatedAt: new Date().getTime(),
            end: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          };
          await window.db.trialTask.insert(task);
        }
      }
    }finally{
      window.updatingDatabase = false;
      console.log('update database complete');
      if(window.callsWhileUpdating > 0){
        window.updatingDatabase = false;
        console.log('*** UDFS updating database again with new changes');
        this.updateDatabaseFromState();
      }else if(window.destroyDbOnUpdateComplete){
        console.log("*** UDFS updateDatabaseFromState: destroy database");
        window.db.destroy().then(() => {
          if(!window.runningTest)
            window.db = null;
          window.destroyDbOnUpdateComplete = false;
          console.log("database destroyed");
        });
      }
    }
  }

  async createSessionFromPreviousSession(){
    var clientId = this.state.clientId;
    var providerId = this.state.providerId;

    mountCount += 1;

    console.log('*** CSFPS enter createSessionFromPreviousSession, mountCount: ' + mountCount + ' clientId: ' + clientId + ' providerId: ' + providerId);

    if(!clientId || !providerId){
      console.log('  * missing clientId or providerId, so we cannot save new client data. *');
      //start with a clean slate of session data
      let newState = this.getInitialStateObject();
      //if there is a providerId, get the provider info from the db.
      //(this is the case where there is a providerId from staying logged in, but happens to be no clientId)
      if(providerId){
        var practitioner = await window.db.person.findOne({selector: {id: providerId}}).exec();
        var practitionerJson = practitioner.toJSON();
        if(practitionerJson && this.state?.requestTokenPayload){
          var keepPayload = await this.getAllClients(practitionerJson).then(clients => 
                Array.isArray(clients) && clients.some(c => c.username === this.state.requestTokenPayload.clientUsername)
          );
          if (!keepPayload){
            this.updateSession(
              'tempMessage',  {
                icon: 'info',
                title: 'No Client',
                message: `${this.state.requestTokenPayload.clientUsername} is not one of your clients. You may want to let your colaborator know you weren't able to approve their request.`,
                duration: 4000
              }, () => {
                this.updateSession('requestTokenPayload', null);
                if (window.location.search.includes('requestToken=')) {
                  const url = new URL(window.location.href);
                  url.searchParams.delete('requestToken');
                  window.history.replaceState({}, document.title, url.pathname + url.search);
                }
            });
          }
        }
        newState.provider = practitionerJson;
        console.log("   * case where there's a provider but no client. provider: " + JSON.stringify(practitionerJson));
      }
      newState.sessionID = 'noClientSession-DoNotSave';
      this.setState({...newState}, () => {    
        this.setState({isLoading: false}, () =>{
          console.log('load data complete');
        });
      });
      return;
    }

    this.setState({isLoading: true});
    this.setState({loadingMessage: "Loading from database..."});

    //retrieve a client and their sessions based on the client's username.
    var client = await window.db.person.findOne({selector: {id: clientId}}).exec();
    if((window.runningTest || !!window.studyParticipant) && !client){
      client = await window.db.person.findOne({selector: {username: clientId}}).exec();
      if(!client){
        Session.client.id = clientId;
        Session.client.username = clientId;
        Session.client.onlyAvailableLocally = !!window.studyParticipant;
        Session.client.updatedAt = new Date().getTime();
        client = await window.db.person.insert(_.cloneDeep(Session.client));
      }
    }
    var clientJson = client.toJSON();

    practitioner = await window.db.person.findOne({selector: {id: providerId}}).exec();
    if((window.runningTest || !!window.studyParticipant) && !practitioner){
      practitioner = await window.db.person.findOne({selector: {username: providerId}}).exec();
      if(!practitioner){
        Session.provider.id = providerId;
        Session.provider.username = providerId;
        Session.provider.onlyAvailableLocally = !!window.studyParticipant;
        Session.provider.updatedAt = new Date().getTime();
        practitioner = await window.db.person.insert(_.cloneDeep(Session.provider));
      }
    }
    practitionerJson = practitioner.toJSON();
    if(practitionerJson && this.state?.requestTokenPayload){
      var keepPayload = await this.getAllClients(practitionerJson).then(clients => 
            Array.isArray(clients) && clients.some(c => c.username === this.state.requestTokenPayload.clientUsername)
      );
      if (!keepPayload){
        this.updateSession(
          'tempMessage',  {
            icon: 'info',
            title: 'No Client',
            message: `${this.state.requestTokenPayload.clientUsername} is not one of your clients. You may want to let your colaborator know you weren't able to approve their request.`,
            duration: 4000
          }, () => {
            this.updateSession('requestTokenPayload', null);
            if (window.location.search.includes('requestToken=')) {
              const url = new URL(window.location.href);
              url.searchParams.delete('requestToken');
              window.history.replaceState({}, document.title, url.pathname + url.search);
            }
        });
      }
    }

    var lastClientSessionJSON = await window.getMostRecentSession(clientJson);

    var allRelatedClinicianIds = await this.getAllProviders(clientJson);
    //TODO what do we want to store for 'client' here? the alias? the username? Have a separate field for each?
    let newSession = {
      id:uuid(),
      start:new Date().getTime(),
      clinicianId: practitionerJson.id,
      clientId: clientJson.id,
      goalIds:[],
      updatedAt: new Date().getTime(),
      end: new Date().getTime(),
      clinicianIds: allRelatedClinicianIds
    };

    var clientSessions = clientJson.sessionIds;
    clientSessions.push(newSession.id);
    if(client)
      await client.incrementalPatch({
        sessionIds: clientSessions,
        updatedAt: new Date().getTime()
      });

    var practitionerSessions = practitionerJson.sessionIds;
    practitionerSessions.push(newSession.id);
    if(practitioner)
      await practitioner.incrementalPatch({
        sessionIds: practitionerSessions,
        updatedAt: new Date().getTime()
      });

    //HHK: Add && false here to turn off retrieving data from database. Allows us to start with blank slate. 
    if(lastClientSessionJSON){
      console.log("  * CSFPS found an existing session for: " + clientJson.alias + " session: " + lastClientSessionJSON.id);
      // window.alert("Found client: " + clientname + " in the database. \nLoading previous session data, if any...");
      this.setState({loadingMessage: "Found client: " + clientJson.alias + " in the database. Loading previous session data..."});

      //set the display names if there are any in the retrieved session data
      //this is not supposed to be their names, it is the id of the person object
      // if(lastClientSessionJSON.clinicianId){
      //   newSession.clinicianId = lastClientSessionJSON.clinicianId;
      // }
      // if(lastClientSessionJSON.clientId){
      //   newSession.clientId = lastClientSessionJSON.clientId;
      // }
      if(lastClientSessionJSON.characteristicsId){
        var previousCharacteristics = await window.db.clientCharacteristics.findOne({selector: {id: lastClientSessionJSON.characteristicsId}}).exec();
        var previousCharacteristicsJSON = previousCharacteristics ? previousCharacteristics.toJSON() : previousCharacteristics;
        let newCharacteristics = {
          id:uuid(),
          bodySites:previousCharacteristicsJSON.bodySites,
          bodySiteComments: previousCharacteristicsJSON.bodySiteComments,
          languageCognition: previousCharacteristicsJSON.languageCognition,
          other: previousCharacteristicsJSON.other,
          updatedAt: new Date().getTime(),
          clinicianIds: allRelatedClinicianIds
        }
        if(previousCharacteristicsJSON.visionId){
          var previousVision = await window.db.visionClientCharacteristics.findOne({selector: {id: previousCharacteristicsJSON.visionId}}).exec();
          var previousVisionJSON = previousVision ? previousVision.toJSON() : previousVision;
          let newVision = {
            id:uuid(),
            wearsGlasses: previousVisionJSON.wearsGlasses,
            betterWithGlasses: previousVisionJSON.betterWithGlasses,
            hasOtherVisualAids: previousVisionJSON.hasOtherVisualAids,
            visualAidsNotes: previousVisionJSON.visualAidsNotes,
            formalEvalNotes: previousVisionJSON.formalEvalNotes,
            visionIssues: previousVisionJSON.visionIssues,
            issuesNotes: previousVisionJSON.issuesNotes,
            updatedAt: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          }
          await window.db.visionClientCharacteristics.insert(newVision);
          newCharacteristics.visionId = newVision.id;
        }else{
          newCharacteristics.visionId = '';
        }
        await window.db.clientCharacteristics.insert(newCharacteristics);
        newSession.characteristicsId = newCharacteristics.id;
      }else{
        newSession.characteristicsId = '';
      }

      if(lastClientSessionJSON.goalIds){
        var previousGoals = await window.db.clientGoal.find({selector:{id: {$in: lastClientSessionJSON.goalIds}}}).exec();
        var previousGoalsJSON = previousGoals.map(x => x.toJSON());
        for(const pg of previousGoalsJSON){
          let newGoal = {
            id:uuid(),
            priority: pg.priority,
            type: pg.type,
            task: pg.task,
            updatedAt: new Date().getTime(),
            clinicianIds: allRelatedClinicianIds
          };
          await window.db.clientGoal.insert(newGoal);
          newSession.goalIds.push(newGoal.id);
        }
      }

      newSession.platforms = lastClientSessionJSON.platforms;
      newSession.platformsUsed = lastClientSessionJSON.platformsUsed;
      newSession.locations = lastClientSessionJSON.locations;
      newSession.positions = lastClientSessionJSON.positions;
      newSession.independentSetup = lastClientSessionJSON.independentSetup;
      newSession.independentUse = lastClientSessionJSON.independentUse;
      newSession.firstMethodCategory = lastClientSessionJSON.firstMethodCategory;
      newSession.historyIds = lastClientSessionJSON.historyIds;
      newSession.trialIds = lastClientSessionJSON.trialIds;
      newSession.summaryNotes = lastClientSessionJSON.summaryNotes;
      newSession.backgroundNotes = lastClientSessionJSON.backgroundNotes;
      newSession.abilitiesNotes = lastClientSessionJSON.abilitiesNotes;
      newSession.testdrivesNotes = lastClientSessionJSON.testdrivesNotes;
      newSession.decisionsNotes = lastClientSessionJSON.decisionsNotes;
      newSession.recommendationsNotes = lastClientSessionJSON.recommendationsNotes;

      if(!lastClientSessionJSON.clinicianIds){
        var accessMethods = await window.db.clientAccessMethod.find({selector:{id: {$in: lastClientSessionJSON.historyIds}}}).exec();
        for(const pa of accessMethods){
          await pa.incrementalPatch({
            clinicianIds: allRelatedClinicianIds,
            updatedAt: new Date().getTime()
          });
        }

        var trials = await window.db.trial.find({selector:{id: {$in: lastClientSessionJSON.trialIds}}}).exec();
        for(const pt of trials){
          var trialJson = pt.toJSON();
          var trialTasks = await window.db.trialTask.find({selector:{id: {$in: trialJson.trialTaskIds}}}).exec();
          for(const ptt of trialTasks){
            var trialTaskJSON = ptt.toJSON();
            var trialTaskComponents = await window.db.trialTaskComponent.find({selector:{id: {$in: trialTaskJSON.trialTaskComponentIds}}}).exec();
            for(const pttc of trialTaskComponents){
              await pttc.incrementalPatch({
                clinicianIds: allRelatedClinicianIds,
                updatedAt: new Date().getTime()
              });
            }

            await ptt.incrementalPatch({
              clinicianIds: allRelatedClinicianIds,
              updatedAt: new Date().getTime()
            });
          }

          var trialReviews = await window.db.trialReview.find({selector:{id: {$in: trialJson.reviewIds}}}).exec();
          for(const ptr of trialReviews){
            await ptr.incrementalPatch({
              clinicianIds: allRelatedClinicianIds,
              updatedAt: new Date().getTime()
            });
          }

          await pt.incrementalPatch({
            clinicianIds: allRelatedClinicianIds,
            updatedAt: new Date().getTime()
          });
        }
      }
    }
    else{
      console.log("  * CSFPS creating a new empty session for: " + clientJson.alias);
      //these fields are those in the database (not same as those in this.state)
      newSession.goalIds = [];
      newSession.platforms = [];
      newSession.platformsUsed = [];
      newSession.characteristicsId = '';
      newSession.locations = [];
      newSession.positions = [];
      newSession.independentSetup = '';
      newSession.independentUse = '';
      newSession.firstMethodCategory = '';
      newSession.historyIds = [];
      newSession.trialIds = [];
      newSession.summaryNotes = '';
      newSession.backgroundNotes = '';
      newSession.abilitiesNotes = '';
      newSession.testdrivesNotes = '';
      newSession.decisionsNotes = '';
      newSession.recommendationsNotes = '';
      newSession.updatedAt = new Date().getTime();
    }
    var result = await window.db.session.insert(newSession);

    //put the new sessionID in the state, 
    //then translate the database-style data into this.state-style data, so the App can use it
    this.setState({
      provider: practitionerJson,
      client: clientJson,
      sessionID: newSession.id
    }, () => this.flattenDbSession());
    console.log('*** Exit CSFPS created and inserted a new session: ', newSession);
  }

  saveTestDrivesToSession = () => {
    window.updateSession('completedTestDrives', this.state.completedTestDrives);
  }
  saveProspectsToSession = () => {
    window.updateSession('prospects', this.state.prospects);
    //this updateDatabase seems redundant but App.test ('Test drive added to completedTestDrives, prospects, and picks') doesn't pass without it
    this.updateDatabaseFromState();
  }
  savePicksToSession = () => {
    window.updateSession('picks', this.state.picks);
    //this updateDatabase seems redundant but App.test ('Test drive added to completedTestDrives, prospects, and picks') doesn't pass without it
    this.updateDatabaseFromState();
  }

  updateSession(key, value, callback){
    console.log("*App state update: key: " + key + " with new value: " + JSON.stringify(value));
    const oldVal = this.state[key];
    console.log("Old value: " + oldVal);
    this.setState({
      [key]: value
    }, () => this.reconcileData(key, value, oldVal, callback));
    //TODO Could POST the new state to server here. (or in onContinue in the sub-section)
    //See https://www.pivotaltracker.com/story/show/180648825 for notes on updating global state
    // console.log(" Just before updateDatabase call, window.db: " + window.db);
    // if(window.db)
    //   this.updateDatabaseFromState();
  }

  reconcileData(key, newVal, oldVal, callback){
    console.log("reconcileData, k: " + key + ", v: " + newVal + ", oldVal: " + oldVal + ", sessionID: " + this.state.sessionID);
    if(key === 'provider'){
      if(newVal?.id !== oldVal?.id){
        window.updateSession("providerId", newVal ? newVal.id : '');
      }
      if(!oldVal && newVal && this.state?.requestTokenPayload){
        this.getAllClients(newVal).then(clients => {
          if(Array.isArray(clients) && clients.some(c => c.username === this.state.requestTokenPayload.clientUsername)){
            this.updateSession(
              'tempMessage',  {
                icon: 'info',
                title: 'No Client',
                message: `${this.state.requestTokenPayload.clientUsername} is not one of your clients. You may want to let your colaborator know you weren't able to approve their request.`,
                duration: 4000
              }, () => {
                this.updateSession('requestTokenPayload', null);
                if (window.location.search.includes('requestToken=')) {
                  const url = new URL(window.location.href);
                  url.searchParams.delete('requestToken');
                  window.history.replaceState({}, document.title, url.pathname + url.search);
                }
            });
          }
        });
      }
    }else if(key === "providerId"){
      window.providerId = newVal;
      if(newVal !== oldVal){
        window.updateSession("client", null);
        if(!window.runningTest){
          this.updateHeadersWithClinician(newVal);
        }
      }
      if(!window.studyParticipant)
        localStorage.setItem(LS_Provider_KEY, newVal ?? '');
    }else if(key === 'client'){
      if(newVal?.id !== oldVal?.id){
        window.updateSession("clientId", newVal ? newVal.id : '');
      }
    }else if(key === 'clientId'){
      window.clientId = newVal;
      if(newVal !== oldVal){
        // reset test drive and session info
        window.updateSession("activeTestDriveId", '');
        window.updateSession("activeTrialTaskId", '');
        this.createSessionFromPreviousSession(); 
      }
      if(!window.studyParticipant)
        localStorage.setItem(LS_Client_KEY, newVal ?? '');
    }
    else if(key === 'stayLoggedIn'){
      localStorage.setItem(LS_StayLoggedIn_Key, newVal);
    }
    else if(key === 'showError'){
      window.showError = !!newVal;
    }else if(key === 'tempMessage'){
      window.updateSession('showTempMessage', !!newVal);
    }else if (key === 'showTempMessage'){
      if(newVal){
        if(this.state.tempMessageTimeoutId)
          clearTimeout(this.state.tempMessageTimeoutId);
        if(this.state.tempMessage && !(this.state.tempMessage.duration < 0))
        {
          this.updateSession('tempMessageTimeoutId', setTimeout(() => {
            window.updateSession('tempMessage', null);
            clearTimeout(this.state.tempMessageTimeoutId);
          }, this.state.tempMessage.duration ?? 5000)); // show toasts for 5 sec if no duration specified
        }
      }else{
        this.updateSession('tempMessageTimeoutId', null);
      }
    }
    else if(key === 'tempMessageTimeoutId'){
      //do nothing for this key. (Ensures it doesn't go to fallback condition and unnecessarily call updateDatabaseFromState)
    }
    else if(key === 'activeTestDriveId'){
      if((newVal && oldVal && (newVal !== oldVal)) && window.db && this.state.sessionID){
        console.log("  * recData, there's a new activeTestDriveId");
        this.resetActiveTestDrive(); //note that this calls updateSession with empty string for activeTrialTaskId
      }
      localStorage.setItem(LS_TestDrive_KEY, newVal);
      window.activeTestDriveId = newVal;
    }
    else if(key === 'activeTrialTaskId'){
      if((newVal && oldVal && (newVal !== oldVal)) && window.db && this.state.sessionID){
        console.log("  * recData, there's a new activeTrialTaskId");
        // this.resetActiveTestDriveTask();
      }
      localStorage.setItem(LS_Task_KEY, newVal);
      window.activeTestDriveActivityId = newVal;
    }
    else if(key === 'activeTestDrive'){
      this.saveActiveTestDrive();
    }
    else if(window.db && (newVal !== oldVal) && !uiStateVars.includes(key)){
      console.log("  * recData, other data updated. Store in database. Key: " + key);
      this.updateDatabaseFromState();
    }
    if (typeof callback === 'function') {
      callback(); // Call the callback so future calls can await successful changes
  }
  }

  componentDidMount(){
    console.log("*** start this.componentDidMount. Check for data in localStorage");
    if(window.testDriveClinicianId || window.practiceBuiltInActivityType){
      console.log("  * this.componentDidMount ** running remote test or practice, don't load anything from localStorage");
      if(createDatabase){
        this.createRxDb().catch(err => {
          console.log('createRxDb() threw an error:');
          console.error(err);
        });
      }
    }else{
      const providerId = window.studyParticipant ? 
          window.studyParticipant.slice(0, 4) : // First 4 characters of studyParticipant are providerId
          localStorage.getItem(LS_Provider_KEY);

      const clientId = window.studyParticipant ? 
          window.studyParticipant.slice(-4) : // Last 4 characters of studyParticipant are clientId
          localStorage.getItem(LS_Client_KEY); 

      const stayLoggedIn = !(localStorage.getItem(LS_StayLoggedIn_Key) === "false");
      window.runningTest = localStorage.getItem(LS_RunningTests_KEY);
      //Login the stored provider if the stayLoggedIn flag is set
      if (providerId && stayLoggedIn){
        console.log("  * this.componentDidMount ** activeTrialTaskId ** is: " + localStorage.getItem(LS_Task_KEY));
        this.setState(
          {
            'providerId': providerId,
            'clientId': clientId,
            'activeTestDriveId': localStorage.getItem(LS_TestDrive_KEY),
            'activeTrialTaskId':localStorage.getItem(LS_Task_KEY),
            'stayLoggedIn': stayLoggedIn
          }, 
          () => {
            if(createDatabase){
              this.createRxDb().catch(err => {
                console.log('createRxDb() threw an error:');
                console.error(err);
              });
            }
          });
      }else{
        this.setState({
          'stayLoggedIn': stayLoggedIn
        }, 
        () => {
          if(createDatabase){
            this.createRxDb().catch(err => {
              console.log('createRxDb() threw an error:');
              console.error(err);
            });
          }
        });
      }
    }
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, clinicianExists: !!this.state.providerId, clientExists: !!this.state.clientId });
    console.log("*** END this.componentDidMount.");
  }

  componentWillUnmount(){
    if(window.db){
      if(window.updatingDatabase){
        console.log("App.componentWillUnmount: still updatingDatabase, don't destroy");
        window.destroyDbOnUpdateComplete = true;
      }else{
        console.log("App.componentWillUnmount: destroy database");
        window.db.destroy().then(() => {
          if(!window.runningTest)
            window.db = null;
          window.destroyDbOnUpdateComplete = false;
          console.log("database destroyed");
        });
      }
    }
    console.log("At the end of App.componentWillUnmount");
  }

  componentDidUpdate(prevProps, prevState){
    console.log("*** App.componentDidUpdate, prevState: " + JSON.stringify(prevState) + ", newState: " + JSON.stringify(this.state));
    if(window.location.pathname + window.location.search !== prevState.currentPath){
      ReactGA.send({ 
        hitType: "pageview", 
        page: window.location.pathname + window.location.search, 
        clinicianExists: !!this.state.providerId, 
        clientExists: !!this.state.clientId });
      this.setState({currentPath: window.location.pathname + window.location.search});
    }
  }

  //Render a route for each UI tab
  //Include all state relevant to that tab to send in as props
  render() {
    console.log("*** App.render(), push down state: " + JSON.stringify(this.state));
    const showAccessRequestPopup = this.state.requestTokenPayload && this.state.provider;
    //<Header> is on repeat so that it re-renders with every route change (to turn the tabbed nav off or on appropriately)
    return (
      <BrowserRouter>
      <ScrollToTop/>
      <div>
        {this.state.isLoading && 
        <Modal isOpen={true}>
          <ModalHeader>One Moment Please...</ModalHeader> 
          <ModalBody>
          <div className="text-center"><Spinner>Loading...</Spinner></div>
          <p>{this.state.loadingMessage}</p>
          </ModalBody>             
        </Modal>
        }
        {this.state.showError && 
        <Modal isOpen={true}>
          <ModalHeader>Application Error</ModalHeader> 
          <ModalBody>
          <p>{this.state.errorMessage}</p>
          </ModalBody>             
        </Modal>
        }
        {this.state.returnToOtherComputer && !window.practiceBuiltInActivityType &&
        <Modal isOpen={true}>
          <ModalHeader>Test Drive Activity Complete</ModalHeader> 
          <ModalBody>
          <p>This Activity is complete. Please close this tab and return to the computer performing the Evaluation.</p>
          </ModalBody>             
        </Modal>
        }
        {this.state.returnToOtherComputer && !!window.practiceBuiltInActivityType &&
        <Modal isOpen={true}>
          <ModalHeader>Test Drive Activity Complete</ModalHeader> 
          <ModalBody>
          <p>Practice complete! Please close this tab and return to the computer performing the Evaluation. Click Back on that computer to move on from practice.</p>
          </ModalBody>             
        </Modal>
        }
        {this.state.tempMessage &&
        <ToastMessage 
          showToast = {this.state.showTempMessage}
          icon = {this.state.tempMessage.icon}
          title = {this.state.tempMessage.title}
          label = {this.state.tempMessage.label}
          message = {this.state.tempMessage.message}
        />
        }
        {this.state.accessRequest && (
          <Modal isOpen={true}>
            <ModalHeader>Send Access Request</ModalHeader>
            <ModalBody>
              <p>
              You can send this request to your colleague<br />
              -------------------------------------------<br />
              {this.state.provider.alias} is requesting shared access to one of your Access Navigator clients.<br />
              <br />
              Topic: Request for access to Access Navigator Client 
              <br/><br/>
              Link: <span style={{display: 'block', wordBreak: 'break-all', whiteSpace: 'pre-wrap'}}>{this.state.accessRequest?.url}</span>
              <br />
              I am requesting shared access to the client data for {this.state.accessRequest?.clientUsername}. Please use the link above to approve my access request.
              </p>
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                  // Handle "Close" action here
                  if (typeof window.sendClientAccessRequest === "function") {
                    window.sendClientAccessRequest(0);
                  }}}
                  >Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                  // Handle "Copy Request Link" action here
                  if (typeof window.sendClientAccessRequest === "function") {
                    window.sendClientAccessRequest(2);
                  }}}
                  >Copy Full Request
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                  // Handle "Copy Request Link" action here
                  if (typeof window.sendClientAccessRequest === "function") {
                    window.sendClientAccessRequest(3);
                  }}}
                  >Copy Link Only
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!navigator.share}
                  onClick={() => {
                  // Handle "Share" action here
                  if (typeof window.sendClientAccessRequest === "function") {
                    window.sendClientAccessRequest(1);
                  }}}
                  >Share
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!this.state.accessRequest?.clinicianEmail}
                  onClick={() => {
                  // Handle "Email Request" action here
                  if (typeof window.sendClientAccessRequest === "function") {
                    window.sendClientAccessRequest(4);
                  }}}
                  >Email Request
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
        {showAccessRequestPopup && (
          <Modal isOpen={true}>
            <ModalHeader>Approve Access Request</ModalHeader>
            <ModalBody>
              <p>
              {this.state.requestTokenPayload?.requestingClinicianName} is requesting access to client data for <b>{this.state.requestTokenPayload?.clientUsername}</b>.<br />
              Do you want to grant access?
              </p>
              <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                  // Handle "Yes" action here
                  // For example, call an approve function or update state
                  if (typeof window.clientAccessApproval === "function") {
                    window.clientAccessApproval(true);
                  }}}
                >Yes</button>
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                  // Handle "No" action here
                  if (typeof window.clientAccessApproval === "function") {
                    window.clientAccessApproval(false);
                  }}}
                >No</button>
              </div>
            </ModalBody>
          </Modal>
        )}
        {/* include Header in every route, so the Header component will know the path (to compute isEval). (if we use <Switch>, must put header in every route) */}
        <Switch>
          <Route exact path="/">
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <HomeWelcome userType={window.userType}/>
            <Footer />
          </Route>
          <Route exact path={EVAL_INTRO}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <DoAnEvalHome firstName={this.state.client ? this.state.client.alias : "the client"} pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}/>
            <Footer />
          </Route>
          <Route exact path={ABOUT_URL}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <StaticAbout firstName={this.state.client ? this.state.client.alias : "the client"} pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}/>
            <Footer />
          </Route>
          <Route exact path={RESOURCES_URL}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <StaticResources firstName={this.state.client ? this.state.client.alias : "the client"} pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}/>
            <Footer />
          </Route>
          <Route exact path={PRIVACY_URL}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <StaticPrivacy firstName={this.state.client ? this.state.client.alias : "the client"} pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}/>
            <Footer />
          </Route>
          <Route path={TABS.GATHER}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <GatherInfo 
            firstName={this.state.client ? this.state.client.alias : "the client"} 
            pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}
            mainGoal={this.state.mainGoal}
            activities={this.state.activities}
            priority={this.state.priority}
            platforms={this.state.platforms}
            environments={this.state.environments}
            bodyPositions={this.state.bodyPositions}
            indepSetup={this.state.indepSetup}
            indepUse={this.state.indepUse}
            hasCurrentMethod={this.state.hasCurrentMethod}
            currentMethods={this.state.currentMethods}
            pastMethods={this.state.pastMethods}
            platformsUsed={this.state.platformsUsed}
            updateSession={window.updateSession}
            />
            <Footer />
          </Route>
          <Route path={TABS.EVAL}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <EvaluateAbilities 
            firstName={this.state.client ? this.state.client.alias : "the client"} 
            pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}
            bodySites={this.state.bodySites}
            bodySiteComments={this.state.bodySiteComments}
            wearsGlasses={this.state.wearsGlasses}
            betterWithGlasses={this.state.betterWithGlasses}
            hasOtherVisualAids={this.state.hasOtherVisualAids}
            visualAidsNotes={this.state.visualAidsNotes}
            formalEvalNotes={this.state.formalEvalNotes}
            visionIssues={this.state.visionIssues}
            issuesNotes={this.state.issuesNotes}
            strengths={this.state.strengths}
            limitations={this.state.limitations}
            otherIssues={this.state.otherIssues}
            updateSession={window.updateSession}
            />
            <Footer />
          </Route>
          <Route path={TABS.TEST}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <TestDrive
            firstName={this.state.client ? this.state.client.alias : "the client"} 
            pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}
            provider={this.state.provider}
            //to change little things based on low-tech pathway
            isLowTechPath={isActivityLowTech(this.state.priority)}
            //to show already chosen bodySites during setup
            bodySites={this.state.bodySites}
            hasCurrentMethod={this.state.hasCurrentMethod}
            firstMethodCategory={this.state.firstMethodCategory}

            //activeTestDriveId managed outside of the test-drive object to be compatible with legacy code.
            //(But the activeTestDrive also has a .id which is intended to be the same as activeTestDriveId)
            //The .id is used in saveActiveTestDrive to tell if we've saved this test-drive yet or now
            activeTestDriveId={this.state.activeTestDriveId}
            activeTestDriveActivityId={window.testDriveTaskId ?? this.state.activeTrialTaskId}
            activeTestDrive={this.state.activeTestDrive}
            completedTestDrives={this.state.completedTestDrives}
            saveAndResetTestDrive={this.saveAndResetTestDrive}
            updateSession={window.updateSession}
            />
            <Footer />
          </Route>
          <Route path={TABS.REVIEW}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <ReviewTab
            firstName={this.state.client ? this.state.client.alias : Session.client.firstName} 
            pronouns={this.state.client ? this.state.client.pronouns : Session.client.pronouns}
            providerName={this.state.provider ? this.state.provider.alias : Session.provider.firstName}
            //props for checklist criteria:
            priority={this.state.priority}
            platforms={this.state.platforms}
            environments={this.state.environments}
            bodyPositions={this.state.bodyPositions}
            //props for comparing and choosing from tested setups
            completedTestDrives={this.state.completedTestDrives}
            prospects={this.state.prospects}
            picks={this.state.picks}
            //TODO decide the best way to pass all the data in to generate a report
            reportData={this.state}
            //TODO OK to manage each type of note separately, instead of in report{}. 
            //This is consistent with other sections, so keep it for now
            summaryNotes={this.state.summaryNotes}
            backgroundNotes={this.state.backgroundNotes}
            abilitiesNotes={this.state.abilitiesNotes}
            testdrivesNotes={this.state.testdrivesNotes}
            decisionsNotes={this.state.decisionsNotes}
            recommendationsNotes={this.state.recommendationsNotes}
            updateSession={window.updateSession}
            />
            <Footer />
          </Route>
          <Route path={[USERS + "/:step", USERS]}>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <UsersTab 
            provider={this.state.provider}
            providerClients={this.state.providerClients}
            client={this.state.client}
            resetToken={window.resetToken}
            stayLoggedIn={this.state.stayLoggedIn}
            checkUserCredentials={window.checkUserCredentials}  
            updateUserCredentials={window.updateUserCredentials}
            resetPassword={window.resetPassword}
            createUser={window.createUser}
            updateUser={window.updateUser}
            getAllClients={window.getAllClients}
            createClientAccessRequest={window.createClientAccessRequest}
            updateSession={window.updateSession}
            />
            <Footer />
          </Route>
          <Route render={({location}) => 
            <>
            <Header client={this.state.client} provider={this.state.provider} userType={window.userType} studyParticipant={window.studyParticipant} prospects={this.state.prospects} picks={this.state.picks} onLogout={window.logoutOfProvider}/>
            <div>404 {location.pathname} Not Found</div>
            <Footer />
            </>
          }/>
          <Redirect to="/" />
        </Switch>
      </div>
      </BrowserRouter>
    );
  }

async createRxDb(){
//Data sync code
console.log('*** start createRxDb()');
console.log("  * connecting to backend, port=" + process.env.PORT + ", reactPort=" + process.env.REACT_APP_PORT);
this.setState({isLoading: true});
this.setState({loadingMessage: "Creating local database..."});
const port = process.env.REACT_APP_PORT || process.env.PORT || 4000;
const isLocal = window.location.hostname === 'localhost';
const syncUrl = isLocal ? 
  'http://' + window.location.hostname + ':' + port + GRAPHQL_PATH : 
  'https://' + window.location.hostname + GRAPHQL_PATH ;
const syncUrls = {
  http: syncUrl
};

console.log("  * connecting to backend, syncUrl=" + syncUrl);

const pushBatchSize = 10;
const pullBatchSize = 100;


// function getStorage(){
//   return getRxStoragePouch('idb');
// }

async function run(){
  console.log('*** start App.run()');

  if(window.practiceBuiltInActivityType){
    await window.runRemotePractice();
    window.updateSession('isLoading', false, () => {
      console.log('database creation skipped');
    });
    return;
  }

  //return;
  let ignoreDuplicate = window.runningTest === 'true';
  const db = await createRxDatabase({
    name: 'accessassistant_app',
    storage : wrappedValidateAjvStorage({
      storage: wrappedKeyEncryptionCryptoJsStorage({
        storage: getRxStorageDexie()
      })
    }),
    password: process.env.AN_DB_PASSWORD ?? 'localPassword',
    eventReduce: true,
    ignoreDuplicate : ignoreDuplicate,
    multiInstance: !ignoreDuplicate
  });
  console.log('  * App.run, db.token: ' + db.token);
  console.log('  * App.run, db.storageToken: ' + db.storageToken);
  window.db = db;

  // wait until data has been pulled
  db.waitForLeadership().then(function() {
  });

  // db.$.subscribe(changeEvent => console.dir('db event: ' + changeEvent));

  const collectionAddition = await db.addCollections({
    // accessMethod: {
    //     schema: accessMethodSchema,
    //     migrationStrategies:{
    //       1: function(oldDoc){
    //         return oldDoc;
    //       },
    //       2: function(oldDoc){
    //         return oldDoc;
    //       },
    //       3: function(oldDoc){
    //         return oldDoc;
    //       },
    //       4: function(oldDoc){
    //         return oldDoc;
    //       },
    //       5: function(oldDoc){
    //         return oldDoc;
    //       },
    //       6: function(oldDoc){
    //         return oldDoc;
    //       },
    //       7: function(oldDoc){
    //         return oldDoc;
    //       },
    //       8: function(oldDoc){
    //         return oldDoc;
    //       }
    //     },
    //     autoMigrate: true
    // },
    clientAccessMethod:{
      schema: clientAccessMethodSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
        11: function(oldDoc){
          return oldDoc;
        },
        12: function(oldDoc){
          return oldDoc;
        },
        13: function(oldDoc){
          return oldDoc;
        },
        14: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    clientCharacteristics:{
      schema: clientCharacteristicsSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    clientGoal:{
      schema: clientGoalSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    person: {
      schema: personSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
        11: function(oldDoc){
          var newDoc = oldDoc;
          newDoc.email = oldDoc.email ?? '';
          newDoc.password = oldDoc.password ?? '';
          return newDoc;
        },
        12: function(oldDoc){
          return oldDoc;
        },
        13: function(oldDoc){
          var newDoc = oldDoc;
          newDoc.token = oldDoc.token ?? '';
          newDoc.tokenExpiration = oldDoc.tokenExpiration ?? 0;
          return newDoc;
        },
        14: function(oldDoc){
          return oldDoc;
        },
        15: function(oldDoc){
          return oldDoc;
        },
        16: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    session:{
      schema: sessionSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          var newDoc = oldDoc;
          if(!newDoc.characteristicsId && oldDoc.characteristics)
            newDoc.characteristicsId = oldDoc.characteristics;
          return newDoc;
        },
        11: function(oldDoc){
          return oldDoc;
        },
        12: function(oldDoc){
          return oldDoc;
        },
        13: function(oldDoc){
          return oldDoc;
        },
        14: function(oldDoc){
          return oldDoc;
        },
        15: function(oldDoc){
          return oldDoc;
        },
        16: function(oldDoc){
          return oldDoc;
        }
      },
      autoMigrate: true
    },
    trialReview:{
      schema: trialReviewSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
        11: function(oldDoc){
          return oldDoc;
        },
        12: function(oldDoc){
          return oldDoc;
        },
        13: function(oldDoc){
          return oldDoc;
        },
        14: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    trial:{
      schema: trialSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
        11: function(oldDoc){
          return oldDoc;
        },
        12: function(oldDoc){
          return oldDoc;
        },
        13: function(oldDoc){
          return oldDoc;
        },
        14: function(oldDoc){
          return oldDoc;
        },
        15: function(oldDoc){
          return oldDoc;
        },
        16: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    trialTask:{
      schema: trialTaskSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          if(Array.isArray(oldDoc.taskNotes)){
            oldDoc.taskNotes = oldDoc.taskNotes[0];
          }
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
        11: function(oldDoc){
          if(oldDoc.timePerTarget){
            oldDoc.targetsPerMinute = 60 / Number(oldDoc.timePerTarget);
          }
          return oldDoc;
        },
        12: function(oldDoc){
          return oldDoc;
        },
        13: function(oldDoc){
          return oldDoc;
        },
        14: function(oldDoc){
          return oldDoc;
        },
        15: function(oldDoc){
          return oldDoc;
        },
        16: function(oldDoc){
          oldDoc.duration = oldDoc.duration ?? '';
          return oldDoc;
        },
        17: function(oldDoc){
          return oldDoc;
        },
        18: function(oldDoc){
          return oldDoc;
        },
        19: function(oldDoc){
          oldDoc.rawWordsPerMinute = oldDoc.rawWordsPerMinute ?? '';
          return oldDoc;
        },
        20: function(oldDoc){
          return oldDoc;
        },
        21:function(oldDoc){
          return oldDoc;
        },
        22:function(oldDoc){
          return oldDoc;
        },
        23: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    trialTaskComponent:{
      schema: trialTaskComponentSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
        11: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    },
    visionClientCharacteristics:{
      schema: visionClientCharacteristicsSchema,
      migrationStrategies:{
        1: function(oldDoc){
          return oldDoc;
        },
        2: function(oldDoc){
          return oldDoc;
        },
        3: function(oldDoc){
          return oldDoc;
        },
        4: function(oldDoc){
          return oldDoc;
        },
        5: function(oldDoc){
          return oldDoc;
        },
        6: function(oldDoc){
          return oldDoc;
        },
        7: function(oldDoc){
          return oldDoc;
        },
        8: function(oldDoc){
          return oldDoc;
        },
        9: function(oldDoc){
          return oldDoc;
        },
        10: function(oldDoc){
          return oldDoc;
        },
      },
      autoMigrate: true
    }
  });

  collectionAddition.clientAccessMethod.getMigrationState().$.subscribe({
    state: (state) => console.dir('clientAccessMethod migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError',  true); 
        window.updateSession('errorMessage', 'clientAccessMethod migration error: ' + error);
      }
      console.error('clientAccessMethod migration error: ' + error);
    },
    done: (done) => console.log('clientAccessMethod migration done ' + done)
  });

  collectionAddition.clientCharacteristics.getMigrationState().$.subscribe({
    state: (state) => console.dir('clientCharacteristics migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'clientCharacteristics migration error: ' + error);
      }
      console.error('clientCharacteristics migration error: ' + error);
    },
    done: (done) => console.log('clientCharacteristics migration done ' + done)
  });

  collectionAddition.clientGoal.getMigrationState().$.subscribe({
    state: (state) => console.dir('clientGoal migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true ); 
        window.updateSession('errorMessage', 'clientGoal migration error: ' + error);
      }
      console.error('clientGoal migration error: ' + error);
    },
    done: (done) => console.log('clientGoal migration done ' + done)
  });

  collectionAddition.person.getMigrationState().$.subscribe({
    state: (state) => console.dir('person migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'person migration error: ' + error);
      }
      console.error('person migration error: ' + error);
    },
    done: (done) => console.log('person migration done ' + done)
  });

  collectionAddition.session.getMigrationState().$.subscribe({
    state: (state) => console.dir('session migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'session migration error: ' + error);
      }
      console.error('session migration error: ' + error);
    },
    done: (done) => console.log('session migration done ' + done)
  });

  collectionAddition.trialReview.getMigrationState().$.subscribe({
    state: (state) => console.dir('trialReview migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trialReview migration error: ' + error);
      }
      console.error('trialReview migration error: ' + error);
    },
    done: (done) => console.log('trialReview migration done ' + done)
  });

  collectionAddition.trial.getMigrationState().$.subscribe({
    state: (state) => console.dir('trial migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trial migration error: ' + error);
      }
      console.error('trial migration error: ' + error);
    },
    done: (done) => console.log('trial migration done ' + done)
  });

  collectionAddition.trialTask.getMigrationState().$.subscribe({
    state: (state) => console.dir('trialTask migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trialTask migration error: ' + error);
      }
      console.error('trialTask migration error: ' + error);
    },
    done: (done) => console.log('trialTask migration done ' + done)
  });

  collectionAddition.trialTaskComponent.getMigrationState().$.subscribe({
    state: (state) => console.dir('trialTaskComponent migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true ); 
        window.updateSession('errorMessage', 'trialTaskComponent migration error: ' + error);
      }
      console.error('trialTaskComponent migration error: ' + error);
    },
    done: (done) => console.log('trialTaskComponent migration done ' + done)
  });

  collectionAddition.visionClientCharacteristics.getMigrationState().$.subscribe({
    state: (state) => console.dir('visionClientCharacteristics migration state: ' + state),
    error: (error) => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'visionClientCharacteristics migration error: ' + error);
      }
      console.error('visionClientCharacteristics migration error: ' + error);
    },
    done: (done) => console.log('visionClientCharacteristics migration done ' + done)
  });
 
  if(connectToBackend && !window.studyParticipant && window.runningTest !== 'true'){
    // set up replication
    window.updateSession('loadingMessage', "Creating connection to remote database...");

    const providerId = hasAValue(window.testDriveClinicianId) ? window.testDriveClinicianId : localStorage.getItem(LS_Provider_KEY);

    // const accessMethodPullQueryBuilder = pullQueryBuilderFromRxSchema(
    //   'accessMethod',
    //   graphQLGenerationInput.accessMethod,
    //   pullBatchSize
    // );
    
    const clientAccessMethodPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'clientAccessMethod',
      graphQLGenerationInput.clientAccessMethod,
      pullBatchSize
    );
    
    const clientCharacteristicsPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'clientCharacteristics',
      graphQLGenerationInput.clientCharacteristics,
      pullBatchSize
    );
    
    const clientGoalPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'clientGoal',
      graphQLGenerationInput.clientGoal,
      pullBatchSize
    );
    
    const personPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'person',
      graphQLGenerationInput.person,
      pullBatchSize
    );
    
    const sessionPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'session',
      graphQLGenerationInput.session,
      pullBatchSize
    );
    
    const trialReviewPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'trialReview',
      graphQLGenerationInput.trialReview,
      pullBatchSize
    );
    
    const trialPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'trial',
      graphQLGenerationInput.trial,
      pullBatchSize
    );
    
    const trialTaskPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'trialTask',
      graphQLGenerationInput.trialTask,
      pullBatchSize
    );
    
    const trialTaskComponentPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'trialTaskComponent',
      graphQLGenerationInput.trialTaskComponent,
      pullBatchSize
    )
    
    const visionClientCharacteristicsPullQueryBuilder = pullQueryBuilderFromRxSchema(
      'visionClientCharacteristics',
      graphQLGenerationInput.visionClientCharacteristics,
      pullBatchSize
    );
    
    const clientAccessMethodPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'clientAccessMethod',
      graphQLGenerationInput.clientAccessMethod
    )
    
    const clientCharacteristicsPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'clientCharacteristics',
      graphQLGenerationInput.clientCharacteristics
    )
    
    const clientGoalPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'clientGoal',
      graphQLGenerationInput.clientGoal
    )
    
    const personPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'person',
      graphQLGenerationInput.person
    )
    
    const sessionPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'session',
      graphQLGenerationInput.session
    )
    
    const trialReviewPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'trialReview',
      graphQLGenerationInput.trialReview
    )
    
    const trialPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'trial',
      graphQLGenerationInput.trial
    )
    
    const trialTaskPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'trialTask',
      graphQLGenerationInput.trialTask
    )
    
    const trialTaskComponentPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'trialTaskComponent',
      graphQLGenerationInput.trialTaskComponent
    )
    
    const visionClientCharacteristicsPullStreamBuilder = pullStreamBuilderFromRxSchema(
      'visionClientCharacteristics',
      graphQLGenerationInput.visionClientCharacteristics
    )
    
    const clientAccessMethodPushQueryBuilder = pushQueryBuilderFromRxSchema(
      'clientAccessMethod',
      graphQLGenerationInput.clientAccessMethod
    );
    
    const clientCharacteristicsPushQueryBuilder = pushQueryBuilderFromRxSchema(
      'clientCharacteristics',
      graphQLGenerationInput.clientCharacteristics
    );
    
    const clientGoalPushQueryBuilder = pushQueryBuilderFromRxSchema(
      'clientGoal',
      graphQLGenerationInput.clientGoal
    );
    
    const personPushQueryBuilder = pushQueryBuilderFromRxSchema(
      'person',
      graphQLGenerationInput.person
    );
    
    const sessionPushQueryBuilder = pushQueryBuilderFromRxSchema(
      "session",
      graphQLGenerationInput.session
    );
    
    const trialReviewPushQueryBuilder = pushQueryBuilderFromRxSchema(
      "trialReview",
      graphQLGenerationInput.trialReview
    );
    
    const trialPushQueryBuilder = pushQueryBuilderFromRxSchema(
      "trial",
      graphQLGenerationInput.trial
    );
    
    const trialTaskPushQueryBuilder = pushQueryBuilderFromRxSchema(
      "trialTask",
      graphQLGenerationInput.trialTask
    );
    
    const trialTaskComponentPushQueryBuilder = pushQueryBuilderFromRxSchema(
      "trialTaskComponent",
      graphQLGenerationInput.trialTaskComponent
    );
    
    const visionClientCharacteristicsPushQueryBuilder = pushQueryBuilderFromRxSchema(
      "visionClientCharacteristics",
      graphQLGenerationInput.visionClientCharacteristics
    );

    // const accessMethodReplicationState = replicateGraphQL({
    //   collection:db.accessMethod,
    //   url: syncUrl,
    //   headers:{
    //     Authorization: 'Bearer ' + JWT_BEARER_TOKEN
    //   },
    //   pull: {
    //     batchSize,
    //     queryBuilder: accessMethodPullQueryBuilder
    //   },
    //   deletedField: 'deleted',
    //   live:true,
    //   retryTime: retryInterval,
    //   waitForLeadership: true,
    //   autoStart:true
    // });

    const clientAccessMethodReplicationState = replicateGraphQL({
      collection: db.clientAccessMethod,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: clientAccessMethodPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: clientAccessMethodPullQueryBuilder,
        streamQueryBuilder: clientAccessMethodPullStreamBuilder,
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const clientCharacteristicsReplicationState = replicateGraphQL({
      collection: db.clientCharacteristics,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: clientCharacteristicsPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: clientCharacteristicsPullQueryBuilder,
        streamQueryBuilder: clientCharacteristicsPullStreamBuilder,
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const clientGoalReplicationState = replicateGraphQL({
      collection: db.clientGoal,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: clientGoalPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: clientGoalPullQueryBuilder,
        streamQueryBuilder: clientGoalPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const personReplicationState = replicateGraphQL({
      collection: db.person,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        relationIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: personPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: personPullQueryBuilder,
        streamQueryBuilder: personPullStreamBuilder,
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const sessionReplicationState = replicateGraphQL({
      collection: db.session,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: sessionPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: sessionPullQueryBuilder,
        streamQueryBuilder: sessionPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const trialReviewReplicationState = replicateGraphQL({
      collection: db.trialReview,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: trialReviewPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: trialReviewPullQueryBuilder,
        streamQueryBuilder: trialReviewPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const trialReplicationState = replicateGraphQL({
      collection: db.trial,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: trialPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: trialPullQueryBuilder,
        streamQueryBuilder: trialPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const trialTaskReplicationState = replicateGraphQL({
      collection: db.trialTask,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: trialTaskPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: trialTaskPullQueryBuilder,
        streamQueryBuilder: trialTaskPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const trialTaskComponentReplicationState = replicateGraphQL({
      collection: db.trialTaskComponent,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: trialTaskComponentPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: trialTaskComponentPullQueryBuilder,
        streamQueryBuilder: trialTaskComponentPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

    const visionClientCharacteristicsReplicationState = replicateGraphQL({
      collection: db.visionClientCharacteristics,
      url: syncUrls,
      headers:{
        Authorization: 'Bearer ' + JWT_BEARER_TOKEN,
        clinicianIds: providerId ? [providerId] : ['']
      },
      push:{
        batchSize: pushBatchSize,
        queryBuilder: visionClientCharacteristicsPushQueryBuilder
      },
      pull: {
        batchSize: pullBatchSize,
        queryBuilder: visionClientCharacteristicsPullQueryBuilder,
        streamQueryBuilder: visionClientCharacteristicsPullStreamBuilder
      },
      deletedField: 'deleted',
      live:true,
      // retryTime: retryInterval,
      // waitForLeadership: false,
      // autoStart:true
    });

        // clear flag waitForDataPull - this flag keeps client list from being loaded until data is pulled
    // after logging into a clinician
    personReplicationState.received$.subscribe(rec => {
      console.warn('person received: curProviderId: ' + window.providerId + ', curClientId: ' + window.clientId + ', received person:');
      console.dir(rec);
      if(rec && rec.id === window.providerId){
        window.updateSession('provider', rec);
      }else if(rec && rec.id === window.clientId){
        window.updateSession('client', rec);
      }else if(rec && rec.relationIds && rec.relationIds.includes(window.providerId)){
        window.refreshPractitioner();
      }
      window.waitForDataPull = false;
    });

    // add watching sessions to determine a this clinician/client combo was updated somewhere else
    sessionReplicationState.received$.subscribe(async (rec) =>{
      // console.debug('session received:');
      // console.dir(rec);
      if(rec && window.sessionID && rec.id !== window.sessionID){
        // session has been received from another computer - check if session has different values
        var response = await window.compareSessions(window.sessionID, rec.id, true);
        // console.debug('incoming session compared, differences:');
        // console.dir(response);
        if(response.session || response.characteristics || response.vision){
          // session has been updated - load data into state so we can show it in the UI
          await window.flattenDbSession();
        }
      }
    });

    clientCharacteristicsReplicationState.received$.subscribe(async (rec) => {
      // console.debug('clientCharacteristic received:');
      // console.dir(rec);
      if(rec && window.characteristicsToWatch && rec.id === window.characteristicsToWatch){
        // clientAccessMethod has been received from another computer - check if session has different values
        var response = await window.compareCharacteristics(window.clientCharacteristicsId, rec.id, true);
        // console.debug('incoming clientCharacteristic compared, differences:');
        // console.dir(response);
        if(response.characteristics){
          // clientAccessMethod has been updated - load data into state so we can show it in the UI
          await window.flattenCharacteristics(window.clientCharacteristicsId, null);
        }
      }
    });

    visionClientCharacteristicsReplicationState.received$.subscribe(async (rec) => {
      // console.debug('visionClientCharacteristics received:');
      // console.dir(rec);
      if(rec && window.visionToWatch && rec.id === window.visionToWatch){
        // visionClientCharacteristics has been received from another computer - check if session has different values
        var response = await window.compareVision(window.clientVisionId, rec.id, true);
        // console.debug('incoming visionClientCharacteristics compared, differences:');
        // console.dir(response);
        if(response.vision){
          // visionClientCharacteristics has been updated - load data into state so we can show it in the UI
          await window.flattenVisionCharacteristics(window.clientVisionId, null);
        }
      }
    });

    trialTaskReplicationState.received$.subscribe(async (rec) => {
      // if(window.testDriveTaskId){
      //   console.debug('trialTask received:');
      //   console.dir(rec);
      // }
      if(rec && (window.activeTestDriveActivityId || window.testDriveTaskId)){
        if((rec.id === window.activeTestDriveActivityId && rec.completed) ||
          (rec.id === window.testDriveTaskId)){
          // completed trialTask has been received from another computer 
          // load data into state so we can show it in the UI
          await window.flattenTrialTask(rec.id, null, null);
        }
      }
    });

    trialTaskComponentReplicationState.received$.subscribe(async (rec) => {
      // if(window.activeTestDriveActivityId){
      //   console.debug('trialTaskComponent received:');
      //   console.dir(rec);
      // }
      if(rec && window.activeTestDriveActivityId && rec.trialTaskId === window.activeTestDriveActivityId){
        await window.flattenTrialTask(rec.trialTaskId, null, null);
      }
    });

    clientAccessMethodReplicationState.error$.subscribe(error => {
      console.log("in clientAccessMethodReplicationState error subscribe");
      if(isErrorToThrow(error)){ 
        console.log("in clientAccessMethodReplicationState / isErrorToThrow block");
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'clientAccessMethod replication error -> ' + error);
      }
      console.error('clientAccessMethodReplicationState replication error:');
      console.dir(error);
    });

    clientCharacteristicsReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'clientCharacteristics replication error -> ' + error);
      }
      console.error('clientCharacteristicsReplicationState replication error:');
      console.dir(error);
    });

    clientGoalReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'clientGoal replication error -> ' + error);
      }
      console.error('clientGoalReplicationState replication error:');
      console.dir(error);
    });

    personReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'person replication error: ' + error);
      }
      console.error('personReplicationState replication error:');
      console.dir(error);
    });

    sessionReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'session replication error: ' + error);
      }
      console.error('sessionReplicationState replication error:');
      console.dir(error);
    });

    trialReviewReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trialReview replication error: ' + error);
      }
      console.error('trialReviewReplicationState replication error:');
      console.dir(error);
    });

    trialReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trial replication error: ' + error);
      }
      console.error('trialReplicationState replication error:');
      console.dir(error);
    });

    trialTaskReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trialTask replication error: ' + error);
      }
      console.error('trialTaskReplicationState replication error:');
      console.dir(error);
    });

    trialTaskComponentReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'trialTaskComponent replication error: ' + error);
      }
      console.error('trialTaskComponentReplicationState replication error:');
      console.dir(error);
    });    
    
    visionClientCharacteristicsReplicationState.error$.subscribe(error => {
      if(isErrorToThrow(error)){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'visionClientCharacteristics replication error: ' + error);
      }
      console.error('visionClientCharacteristicsReplicationState replication error:');
      console.dir(error);
    });

    // set a window var if I want to try to access the checkpoint info
    // hopefully then we can pull sessions for practiionerID
    window.clientAccessMethodReplicationState = clientAccessMethodReplicationState;
    window.clientCharacteristicsReplicationState = clientCharacteristicsReplicationState;
    window.clientGoalReplicationState = clientGoalReplicationState;
    window.personReplicationState = personReplicationState;
    window.sessionReplicationState = sessionReplicationState; 
    window.trialReviewReplicationState = trialReviewReplicationState;
    window.trialReplicationState = trialReplicationState;
    window.trialTaskReplicationState = trialTaskReplicationState;
    window.trialTaskComponentReplicationState = trialTaskComponentReplicationState;
    window.visionClientCharacteristicsReplicationState = visionClientCharacteristicsReplicationState;   

    window.updateSession('loadingMessage', "Retrieving data from remote database...");

    const replicationTimeout = 30000;

  //*** preserve ability to show Application Error modal when running in more than one tab.
  // If this times out, we must be running in more than one tab - alert the user
  await runAllWithTimeout([
      // accessMethodReplicationState.startPromise,
      clientAccessMethodReplicationState.startPromise,
      clientCharacteristicsReplicationState.startPromise,
      clientGoalReplicationState.startPromise,
      personReplicationState.startPromise,
      sessionReplicationState.startPromise,
      trialReviewReplicationState.startPromise,
      trialReplicationState.startPromise,
      trialTaskReplicationState.startPromise,
      trialTaskComponentReplicationState.startPromise,
      visionClientCharacteristicsReplicationState.startPromise
    ], replicationTimeout)
    .catch(error => {
      if(!window.showError){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'Access Navigator is already running in another tab. Please close this tab, and switch to the other tab to avoid data conflicts.');
      }
      console.error(error.message);
    });

  //*** preserve ability to show Application Error
  // If this times out, we must be running in more than one tab - alert the user
    await runAllWithTimeout([
      // accessMethodReplicationState.awaitInSync,
      clientAccessMethodReplicationState.awaitInSync,
      clientCharacteristicsReplicationState.awaitInSync,
      clientGoalReplicationState.awaitInSync,
      personReplicationState.awaitInSync,
      sessionReplicationState.awaitInSync,
      trialReviewReplicationState.awaitInSync,
      trialReplicationState.awaitInSync,
      trialTaskReplicationState.awaitInSync,
      trialTaskComponentReplicationState.awaitInSync,
      visionClientCharacteristicsReplicationState.awaitInSync
    ], replicationTimeout)
    .catch(error => {
      if(!window.showError){
        window.updateSession('showError', true); 
        window.updateSession('errorMessage', 'Access Navigator is already running in another tab. Please close this tab, and switch to the other tab to avoid data conflicts.');
      }
      console.error(error.message);
    });

    setInterval(() => {
      //accessMethodReplicationState.reSync()
      clientAccessMethodReplicationState.reSync()
      clientCharacteristicsReplicationState.reSync()
      clientGoalReplicationState.reSync()
      personReplicationState.reSync()
      sessionReplicationState.reSync()
      trialReviewReplicationState.reSync()
      trialReplicationState.reSync()
      trialTaskReplicationState.reSync()
      trialTaskComponentReplicationState.reSync()
      visionClientCharacteristicsReplicationState.reSync()
    }, 10* 1000); // 10 seconds
    
  } // end of connect to backend conditional block
  console.log('*** END App.run(), just before call to CSFPS');
  if(window.testDriveClinicianId && window.testDriveTaskId){
    window.flattenTrialTask(window.testDriveTaskId, null, null);
  }else{
    window.createSessionFromPreviousSession();
  }
}
//This will show Application Error modal if database creation failed, which is what we want.
  await run().catch(err => {
    console.log('run() threw an error:');
    console.error(err);
    this.setState({
      isLoading: false,
      showError: true,
      errorMessage: this.state.showError ? this.state.errorMessage : 'database creation error: ' + err
    }, () =>{
      console.log('database creation failed');
    });
  });

  console.log('*** END createRxDb()');
} //end of createRxDb() database conditional block
}

//Utility function to check if errors should be thrown
// (Note this is outside of code for class App)
// Returns false to avoid throwing an error.
// When true, we can set state.showError and state.errorMessage to then render a Modal with that message on the next render cycle
// 
// We set this up to show us when database errors were occurring, b/c sometimes those were invisible otherwise.
// The idea was to avoid displaying known conditions that did not warrant a complete halt of the app, but make sure we were alerted to new issues that we might otherwise miss.
// After upgrading our database code, we're seeing spurious database errors after localhost sits unused, like overnight. It is able to recover by itself, so we don't want to see
// these errors any more. 
// Thus we will change this to return false always, to keep spurious messages from showing.
// This can easily be reverted back to the original (see below).

export function isErrorToThrow(err){
  const errorWhiteList = [
    'NetworkError', 
    'Could not connect to any servers in your MongoDB Atlas cluster',
    'TypeError: Failed to fetch',
    'Cannot return null for non-nullable field Query.',
    'was cleared because another operation failed'
  ];
  if(typeof err !== 'string')
    err = err.toString();
  for(let item of errorWhiteList){
    if(err.includes(item)){
      console.log("isErrorToThrow: saw this error but it's in the whiteList: " + err);
      return false;
    }
  }
  console.log("isErrorToThrow: appEnv:" + process.env.REACT_APP_APP_ENVIRONMENT + " err=" + err);

  //always return false for now
  return false;
  //To revert to original logic, and show errors that are not in the whitelist, uncomment the return statement below
  //if we're already showing an error, don't show any other errors. And avoid showing errors in Production environment.
  //return (!window.showError && process.env.REACT_APP_APP_ENVIRONMENT !== 'Production');
}

export default App;
